/* eslint-disable */

// ==================================================================
// 🚨 This file was automatically generated and should not be edited.
// ==================================================================

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
  { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BlockHtml: any;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: string;
  InlineHtml: string;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AdvertisingInfo = {
  __typename: "AdvertisingInfo";
  id: Scalars["ID"];
  disableHouseAd: Scalars["Boolean"];
};

export type AnonymousNewsletterSignup = {
  ids: Array<Scalars["ID"]>;
  email: Scalars["String"];
};

export type AnonymousNewsletterSignupPayload = {
  __typename: "AnonymousNewsletterSignupPayload";
  ids: Array<Scalars["ID"]>;
  email: Scalars["String"];
  existingUser?: Maybe<Scalars["Boolean"]>;
};

export type Article = {
  id: Scalars["ID"];
  url: Scalars["String"];
  title: Scalars["InlineHtml"];
  dek?: Maybe<Scalars["InlineHtml"]>;
  authors: Array<Author>;
  secondaryByline?: Maybe<Scalars["InlineHtml"]>;
  datePublished?: Maybe<Scalars["DateTime"]>;
  dateModified?: Maybe<Scalars["DateTime"]>;
  editorsNote?: Maybe<EditorsNote>;
  layout: ArticleLayout;
  hasMeter?: Maybe<Scalars["Boolean"]>;
  htmlContentSections: Array<ContentSection>;
  leadArt?: Maybe<LeadArt>;
  embeds: Array<Embed>;
  ampUrl?: Maybe<Scalars["String"]>;
  fbiaUrl?: Maybe<Scalars["String"]>;
  originalUrl?: Maybe<Scalars["String"]>;
  canonicalUrl: Scalars["String"];
  primaryCategory?: Maybe<PrimaryCategory>;
  primaryChannel?: Maybe<Channel>;
  channels: Array<Channel>;
  categories: Array<Category>;
  seoDek?: Maybe<Scalars["String"]>;
  seoTitle?: Maybe<Scalars["String"]>;
  shareTitle?: Maybe<Scalars["String"]>;
  shareDek?: Maybe<Scalars["String"]>;
  shareText?: Maybe<Scalars["String"]>;
  shareImage?: Maybe<BasicImage>;
  slug: Scalars["String"];
  editorialProject?: Maybe<EditorialProject>;
  reviews: Array<Review>;
  isFreelance?: Maybe<Scalars["Boolean"]>;
  wordCount: Scalars["Int"];
  editorialMotivation?: Maybe<EditorialMotivation>;
  isPython3?: Maybe<Scalars["Boolean"]>;
  isTnfCompatible: Scalars["Boolean"];
  watsonInfo?: Maybe<WatsonInfo>;
  advertisingInfo?: Maybe<AdvertisingInfo>;
  grapeshot?: Maybe<Grapeshot>;
  preview?: Maybe<Scalars["String"]>;
  content: Array<ArticleContentElement>;
};

export type ArticleShareImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type ArticleAdPlaceholder = {
  __typename: "ArticleAdPlaceholder";
  subtype?: Maybe<InlineAdPlacement>;
};

export type ArticleContentElement =
  | ArticleParagraphContent
  | ArticleHeading
  | ArticleRelatedContentLink
  | ArticlePullquote
  | ArticleInlineImage
  | ArticleWellInlineImage
  | ArticleOverflowInlineImage
  | ArticleRelatedContentModule
  | ArticleLegacyHtml
  | ArticleAdPlaceholder;

export type ArticleHeading = ArticleTextContent & {
  __typename: "ArticleHeading";
  idAttr: Scalars["String"];
  subtype: ArticleHeadingLevel;
  innerHtml: Scalars["InlineHtml"];
};

export enum ArticleHeadingLevel {
  Hed1 = "HED1",
  Hed2 = "HED2",
  Hed3 = "HED3",
  Hed4 = "HED4",
  Hed5 = "HED5",
}

export type ArticleInlineImage = Image & {
  __typename: "ArticleInlineImage";
  id: Scalars["ID"];
  url: Scalars["String"];
  width: Scalars["Int"];
  height: Scalars["Int"];
  attributionText: Scalars["InlineHtml"];
  attributionUrl: Scalars["String"];
  altText: Scalars["String"];
  captionText: Scalars["InlineHtml"];
  alignment?: Maybe<ArticleInlineImageAlignment>;
  srcSet: Scalars["String"];
  clickthroughUrl: Scalars["String"];
};

export enum ArticleInlineImageAlignment {
  Center = "CENTER",
  Left = "LEFT",
  Right = "RIGHT",
  Leftgutter = "LEFTGUTTER",
  Rightgutter = "RIGHTGUTTER",
  Overflow = "OVERFLOW",
  Fullbleed = "FULLBLEED",
  Rightbleed = "RIGHTBLEED",
  Leftbleed = "LEFTBLEED",
}

export enum ArticleLayout {
  Feature = "feature",
  Standard = "standard",
}

export type ArticleLegacyHtml = {
  __typename: "ArticleLegacyHtml";
  tagName: LegacyHtmlTagName;
  idAttr: Scalars["String"];
  className: Scalars["String"];
  style: Scalars["String"];
  innerHtml: Scalars["InlineHtml"];
};

export type ArticleOverflowInlineImage = Image & {
  __typename: "ArticleOverflowInlineImage";
  id: Scalars["ID"];
  url: Scalars["String"];
  width: Scalars["Int"];
  height: Scalars["Int"];
  attributionText: Scalars["InlineHtml"];
  attributionUrl: Scalars["String"];
  altText: Scalars["String"];
  captionText: Scalars["InlineHtml"];
  alignment?: Maybe<ArticleInlineImageAlignment>;
  srcSet: Scalars["String"];
  clickthroughUrl: Scalars["String"];
  crop?: Maybe<BasicCrop>;
};

export type ArticleOverflowInlineImageCropArgs = {
  width: Scalars["Int"];
  height?: Maybe<Scalars["Int"]>;
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type ArticleParagraphContent = ArticleTextContent & {
  __typename: "ArticleParagraphContent";
  idAttr: Scalars["String"];
  subtype?: Maybe<ParagraphSubtype>;
  innerHtml: Scalars["InlineHtml"];
};

export type ArticlePullquote = ArticleTextContent & {
  __typename: "ArticlePullquote";
  idAttr: Scalars["String"];
  innerHtml: Scalars["InlineHtml"];
};

export type ArticleRelatedContentLink = ArticleTextContent & {
  __typename: "ArticleRelatedContentLink";
  idAttr: Scalars["String"];
  innerHtml: Scalars["InlineHtml"];
};

export type ArticleRelatedContentModule = {
  __typename: "ArticleRelatedContentModule";
  subtype: ArticleRelatedContentStyle;
  contentType: ArticleRelatedContentType;
  objectId: Scalars["Int"];
  alignment?: Maybe<ArticleRelatedContentModuleAlignment>;
};

export enum ArticleRelatedContentModuleAlignment {
  Center = "CENTER",
  Left = "LEFT",
  Right = "RIGHT",
  Full = "FULL",
}

export enum ArticleRelatedContentStyle {
  Magazine = "MAGAZINE",
  Curated = "CURATED",
  Editorialproject = "EDITORIALPROJECT",
  Categorization = "CATEGORIZATION",
}

export enum ArticleRelatedContentType {
  Magazine = "MAGAZINE",
  Curated = "CURATED",
  Editorialproject = "EDITORIALPROJECT",
  Category = "CATEGORY",
  Channel = "CHANNEL",
}

export type ArticleTextContent = {
  idAttr: Scalars["String"];
  innerHtml: Scalars["InlineHtml"];
};

export type ArticleWellInlineImage = Image & {
  __typename: "ArticleWellInlineImage";
  id: Scalars["ID"];
  url: Scalars["String"];
  width: Scalars["Int"];
  height: Scalars["Int"];
  attributionText: Scalars["InlineHtml"];
  attributionUrl: Scalars["String"];
  altText: Scalars["String"];
  captionText: Scalars["InlineHtml"];
  alignment?: Maybe<ArticleInlineImageAlignment>;
  srcSet: Scalars["String"];
  clickthroughUrl: Scalars["String"];
  crop?: Maybe<BasicCrop>;
};

export type ArticleWellInlineImageCropArgs = {
  width: Scalars["Int"];
  height?: Maybe<Scalars["Int"]>;
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type Author = List & {
  __typename: "Author";
  id: Scalars["ID"];
  slug: Scalars["String"];
  displayName: Scalars["String"];
  firstName?: Maybe<Scalars["String"]>;
  lastName?: Maybe<Scalars["String"]>;
  headshot?: Maybe<BasicImage>;
  biography?: Maybe<Biography>;
  url: Scalars["String"];
  socialMedia: Array<SocialMedia>;
  river: RiverConnection;
};

export type AuthorHeadshotArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type AuthorRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type AuthorEdge = {
  __typename: "AuthorEdge";
  id: Scalars["ID"];
  cursor: Scalars["String"];
  node: Author;
};

export type AuthorList = {
  id: Scalars["ID"];
  slug: Scalars["String"];
  displayName: Scalars["String"];
  river: AuthorRiverConnection;
};

export type AuthorListRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type AuthorRiverConnection = {
  __typename: "AuthorRiverConnection";
  pageInfo: PageInfo;
  edges: Array<AuthorEdge>;
};

export type BasicCrop = Crop & {
  __typename: "BasicCrop";
  id: Scalars["ID"];
  url: Scalars["String"];
  width: Scalars["Int"];
  height: Scalars["Int"];
  srcSet: Scalars["String"];
};

export type BasicImage = Image & {
  __typename: "BasicImage";
  id: Scalars["ID"];
  url: Scalars["String"];
  width: Scalars["Int"];
  height: Scalars["Int"];
  srcSet: Scalars["String"];
  attributionText: Scalars["InlineHtml"];
  attributionUrl: Scalars["String"];
  altText: Scalars["String"];
  captionText: Scalars["InlineHtml"];
};

export type Biography = {
  __typename: "Biography";
  default?: Maybe<Scalars["InlineHtml"]>;
  short?: Maybe<Scalars["InlineHtml"]>;
  extended?: Maybe<Scalars["BlockHtml"]>;
};

export type BlogArticle = PromoItem &
  Article & {
    __typename: "BlogArticle";
    id: Scalars["ID"];
    url: Scalars["String"];
    title: Scalars["InlineHtml"];
    dek?: Maybe<Scalars["InlineHtml"]>;
    riverImage?: Maybe<BasicImage>;
    authors: Array<Author>;
    secondaryByline?: Maybe<Scalars["InlineHtml"]>;
    datePublished?: Maybe<Scalars["DateTime"]>;
    dateModified?: Maybe<Scalars["DateTime"]>;
    editorsNote?: Maybe<EditorsNote>;
    layout: ArticleLayout;
    hasMeter?: Maybe<Scalars["Boolean"]>;
    htmlContentSections: Array<ContentSection>;
    leadArt?: Maybe<LeadArt>;
    embeds: Array<Embed>;
    ampUrl?: Maybe<Scalars["String"]>;
    fbiaUrl?: Maybe<Scalars["String"]>;
    originalUrl?: Maybe<Scalars["String"]>;
    canonicalUrl: Scalars["String"];
    primaryCategory?: Maybe<PrimaryCategory>;
    seoDek?: Maybe<Scalars["String"]>;
    seoTitle?: Maybe<Scalars["String"]>;
    shareTitle?: Maybe<Scalars["String"]>;
    shareDek?: Maybe<Scalars["String"]>;
    shareText?: Maybe<Scalars["String"]>;
    shareImage?: Maybe<BasicImage>;
    editorialProject?: Maybe<EditorialProject>;
    reviews: Array<Review>;
    primaryChannel?: Maybe<Channel>;
    slug: Scalars["String"];
    categories: Array<Category>;
    channels: Array<Channel>;
    isFreelance?: Maybe<Scalars["Boolean"]>;
    wordCount: Scalars["Int"];
    editorialMotivation?: Maybe<EditorialMotivation>;
    isPython3?: Maybe<Scalars["Boolean"]>;
    isTnfCompatible: Scalars["Boolean"];
    watsonInfo?: Maybe<WatsonInfo>;
    grapeshot?: Maybe<Grapeshot>;
    advertisingInfo?: Maybe<AdvertisingInfo>;
    preview?: Maybe<Scalars["String"]>;
    content: Array<ArticleContentElement>;
  };

export type BlogArticleRiverImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type BlogArticleShareImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type Book = {
  __typename: "Book";
  id: Scalars["ID"];
  creator?: Maybe<Scalars["String"]>;
  creatorUrl?: Maybe<Scalars["String"]>;
  isbn10?: Maybe<Scalars["String"]>;
  isbn13?: Maybe<Scalars["String"]>;
  publisher?: Maybe<Scalars["String"]>;
  thumbnail?: Maybe<BasicImage>;
  title?: Maybe<Scalars["String"]>;
};

export type BookThumbnailArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type BookReview = Review & {
  __typename: "BookReview";
  id: Scalars["ID"];
  title: Scalars["String"];
  creator?: Maybe<Scalars["String"]>;
  creatorUrl?: Maybe<Scalars["String"]>;
  purchaseUrl?: Maybe<Scalars["String"]>;
  image?: Maybe<BasicImage>;
  url?: Maybe<Scalars["String"]>;
  content?: Maybe<Scalars["String"]>;
  publisher?: Maybe<Scalars["String"]>;
  isbn?: Maybe<Scalars["String"]>;
  isbn10?: Maybe<Scalars["String"]>;
  isbn13?: Maybe<Scalars["String"]>;
  asin?: Maybe<Scalars["String"]>;
  bookshopIsbn?: Maybe<Scalars["String"]>;
};

export type BookReviewImageArgs = {
  width?: Maybe<Scalars["Int"]>;
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type BreakingNews = {
  __typename: "BreakingNews";
  id: Scalars["ID"];
  kicker?: Maybe<Scalars["String"]>;
  text: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
  theme: BreakingNewsTheme;
  homepageEnabled: Scalars["Boolean"];
};

export enum BreakingNewsTheme {
  Red = "RED",
  Blue = "BLUE",
  Gray = "GRAY",
}

export enum CacheControlScope {
  Public = "PUBLIC",
  Private = "PRIVATE",
}

export type CachePurgePayload = {
  __typename: "CachePurgePayload";
  success: Scalars["Boolean"];
};

export type Category = List & {
  __typename: "Category";
  id: Scalars["ID"];
  slug: Scalars["String"];
  displayName: Scalars["String"];
  url: Scalars["String"];
  river: RiverConnection;
};

export type CategoryRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type Channel = List & {
  __typename: "Channel";
  id: Scalars["ID"];
  slug: Scalars["String"];
  displayName: Scalars["String"];
  url: Scalars["String"];
  river: RiverConnection;
  pinnedArticle?: Maybe<PromoItem>;
  grapeshot?: Maybe<Grapeshot>;
  editorialProject?: Maybe<EditorialProject>;
};

export type ChannelRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type Cinemagraph = Video & {
  __typename: "Cinemagraph";
  id: Scalars["ID"];
  attributionText?: Maybe<Scalars["String"]>;
  attributionUrl?: Maybe<Scalars["String"]>;
  captionText?: Maybe<Scalars["InlineHtml"]>;
  formats: Array<VideoFormat>;
  height?: Maybe<Scalars["Int"]>;
  width: Scalars["Int"];
  poster?: Maybe<BasicCrop>;
};

export type CinemagraphPosterArgs = {
  width: Scalars["Int"];
  height?: Maybe<Scalars["Int"]>;
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type ContentSection = {
  __typename: "ContentSection";
  main: Scalars["BlockHtml"];
  hasRailAd: Scalars["Boolean"];
};

export type Crop = {
  id: Scalars["ID"];
  url: Scalars["String"];
  width: Scalars["Int"];
  height: Scalars["Int"];
  srcSet: Scalars["String"];
};

export type CuratedArticle = PromoItem & {
  __typename: "CuratedArticle";
  id: Scalars["ID"];
  url: Scalars["String"];
  title: Scalars["InlineHtml"];
  dek?: Maybe<Scalars["InlineHtml"]>;
  riverImage?: Maybe<BasicImage>;
  authors: Array<Author>;
  customByline: Scalars["String"];
  datePublished?: Maybe<Scalars["DateTime"]>;
};

export type CuratedArticleRiverImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type CuratedAuthorGroup = AuthorList & {
  __typename: "CuratedAuthorGroup";
  id: Scalars["ID"];
  slug: Scalars["String"];
  displayName: Scalars["String"];
  river: AuthorRiverConnection;
};

export type CuratedAuthorGroupRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type CuratedGroup = List & {
  __typename: "CuratedGroup";
  id: Scalars["ID"];
  displayName: Scalars["String"];
  slug: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
  grapeshot?: Maybe<Grapeshot>;
  river: RiverConnection;
};

export type CuratedGroupRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type EditorialMotivation = {
  __typename: "EditorialMotivation";
  slug: Scalars["String"];
};

export type EditorialProject = List & {
  __typename: "EditorialProject";
  id: Scalars["ID"];
  foundationLine?: Maybe<Scalars["InlineHtml"]>;
  foundationLineArticle?: Maybe<Scalars["InlineHtml"]>;
  accentColor?: Maybe<Scalars["String"]>;
  textColor?: Maybe<Scalars["String"]>;
  url: Scalars["String"];
  displayName: Scalars["String"];
  slug: Scalars["String"];
  river: RiverConnection;
  titleImage?: Maybe<BasicCrop>;
  leadImage?: Maybe<BasicCrop>;
  presentedByDisplayName?: Maybe<Scalars["String"]>;
  presentedByUrl?: Maybe<Scalars["String"]>;
};

export type EditorialProjectRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type EditorialProjectTitleImageArgs = {
  width: Scalars["Int"];
  height?: Maybe<Scalars["Int"]>;
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type EditorialProjectLeadImageArgs = {
  width: Scalars["Int"];
  height?: Maybe<Scalars["Int"]>;
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type EditorsNote = {
  __typename: "EditorsNote";
  content: Scalars["InlineHtml"];
  datePublished?: Maybe<Scalars["DateTime"]>;
};

export type Embed = {
  __typename: "Embed";
  type: Scalars["String"];
  src: Scalars["String"];
};

export type EpisodeReview = Review & {
  __typename: "EpisodeReview";
  id: Scalars["ID"];
  title: Scalars["String"];
  creator?: Maybe<Scalars["String"]>;
  creatorUrl?: Maybe<Scalars["String"]>;
  purchaseUrl?: Maybe<Scalars["String"]>;
  image?: Maybe<BasicImage>;
  content?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
  season: Scalars["Int"];
  episode: Scalars["Int"];
};

export type EpisodeReviewImageArgs = {
  width?: Maybe<Scalars["Int"]>;
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type Grapeshot = {
  __typename: "Grapeshot";
  segments: Array<Scalars["String"]>;
};

export type HomepageModule = HomepagePromoItem | HomepagePromoItemList;

export type HomepagePromoItem = PromoItem & {
  __typename: "HomepagePromoItem";
  id: Scalars["ID"];
  url: Scalars["String"];
  title: Scalars["InlineHtml"];
  dek?: Maybe<Scalars["InlineHtml"]>;
  kicker?: Maybe<Scalars["String"]>;
  kickerUrl?: Maybe<Scalars["String"]>;
  riverImage?: Maybe<BasicImage>;
  authors: Array<Author>;
  datePublished?: Maybe<Scalars["DateTime"]>;
};

export type HomepagePromoItemRiverImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type HomepagePromoItemList = {
  __typename: "HomepagePromoItemList";
  items: Array<HomepagePromoItem>;
};

export type Image = {
  url: Scalars["String"];
  width: Scalars["Int"];
  height: Scalars["Int"];
  srcSet: Scalars["String"];
  attributionText: Scalars["InlineHtml"];
  attributionUrl: Scalars["String"];
  altText: Scalars["String"];
  captionText: Scalars["InlineHtml"];
};

export enum InlineAdPlacement {
  Manual = "MANUAL",
}

export type Latest = List & {
  __typename: "Latest";
  id: Scalars["ID"];
  slug: Scalars["String"];
  displayName: Scalars["String"];
  url: Scalars["String"];
  river: RiverConnection;
};

export type LatestRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type LeadArt =
  | LeadArtImage
  | LeadArtImageLarge
  | LeadArtEmbed
  | Cinemagraph;

export type LeadArtEmbed = {
  __typename: "LeadArtEmbed";
  src: Scalars["String"];
  width: Scalars["String"];
  height: Scalars["String"];
  caption: Scalars["String"];
  attributes: Array<Array<Scalars["String"]>>;
};

export type LeadArtImage = {
  __typename: "LeadArtImage";
  image?: Maybe<BasicImage>;
};

export type LeadArtImageImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type LeadArtImageLarge = {
  __typename: "LeadArtImageLarge";
  image?: Maybe<BasicImage>;
};

export type LeadArtImageLargeImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export enum LegacyHtmlTagName {
  Div = "DIV",
  Blockquote = "BLOCKQUOTE",
  P = "P",
  Hr = "HR",
  H1 = "H1",
  H2 = "H2",
  H3 = "H3",
  H4 = "H4",
  H5 = "H5",
  H6 = "H6",
  Figure = "FIGURE",
  Aside = "ASIDE",
  Ul = "UL",
  Ol = "OL",
}

export type List = {
  id: Scalars["ID"];
  slug: Scalars["String"];
  displayName: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
  river: RiverConnection;
};

export type ListRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type MagazineArticle = PromoItem &
  Article & {
    __typename: "MagazineArticle";
    id: Scalars["ID"];
    url: Scalars["String"];
    title: Scalars["InlineHtml"];
    dek?: Maybe<Scalars["InlineHtml"]>;
    riverImage?: Maybe<BasicImage>;
    authors: Array<Author>;
    secondaryByline?: Maybe<Scalars["InlineHtml"]>;
    datePublished?: Maybe<Scalars["DateTime"]>;
    dateModified?: Maybe<Scalars["DateTime"]>;
    editorsNote?: Maybe<EditorsNote>;
    layout: ArticleLayout;
    hasMeter?: Maybe<Scalars["Boolean"]>;
    htmlContentSections: Array<ContentSection>;
    leadArt?: Maybe<LeadArt>;
    embeds: Array<Embed>;
    ampUrl?: Maybe<Scalars["String"]>;
    fbiaUrl?: Maybe<Scalars["String"]>;
    originalUrl?: Maybe<Scalars["String"]>;
    canonicalUrl: Scalars["String"];
    primaryCategory?: Maybe<PrimaryCategory>;
    seoDek?: Maybe<Scalars["String"]>;
    seoTitle?: Maybe<Scalars["String"]>;
    shareTitle?: Maybe<Scalars["String"]>;
    shareDek?: Maybe<Scalars["String"]>;
    shareText?: Maybe<Scalars["String"]>;
    shareImage?: Maybe<BasicImage>;
    editorialProject?: Maybe<EditorialProject>;
    issue: MagazineIssue;
    reviews: Array<Review>;
    primaryChannel?: Maybe<Channel>;
    slug: Scalars["String"];
    categories: Array<Category>;
    channels: Array<Channel>;
    isFreelance?: Maybe<Scalars["Boolean"]>;
    wordCount: Scalars["Int"];
    editorialMotivation?: Maybe<EditorialMotivation>;
    isPython3?: Maybe<Scalars["Boolean"]>;
    isTnfCompatible: Scalars["Boolean"];
    watsonInfo?: Maybe<WatsonInfo>;
    grapeshot?: Maybe<Grapeshot>;
    advertisingInfo?: Maybe<AdvertisingInfo>;
    preview?: Maybe<Scalars["String"]>;
    content: Array<ArticleContentElement>;
  };

export type MagazineArticleRiverImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type MagazineArticleShareImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type MagazineIssue = PromoItem & {
  __typename: "MagazineIssue";
  id: Scalars["ID"];
  issueName: Scalars["String"];
  url: Scalars["String"];
  slug: Scalars["String"];
  cover?: Maybe<BasicCrop>;
  title: Scalars["InlineHtml"];
  dek?: Maybe<Scalars["InlineHtml"]>;
  riverImage?: Maybe<BasicImage>;
  authors: Array<Author>;
  datePublished?: Maybe<Scalars["DateTime"]>;
};

export type MagazineIssueCoverArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type MagazineIssueRiverImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type MagazineIssues = List & {
  __typename: "MagazineIssues";
  id: Scalars["ID"];
  slug: Scalars["String"];
  displayName: Scalars["String"];
  url: Scalars["String"];
  river: RiverConnection;
};

export type MagazineIssuesRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type MovieReview = Review & {
  __typename: "MovieReview";
  id: Scalars["ID"];
  title: Scalars["String"];
  creator?: Maybe<Scalars["String"]>;
  creatorUrl?: Maybe<Scalars["String"]>;
  purchaseUrl?: Maybe<Scalars["String"]>;
  image?: Maybe<BasicImage>;
  content?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
};

export type MovieReviewImageArgs = {
  width?: Maybe<Scalars["Int"]>;
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type MusicAlbumReview = Review & {
  __typename: "MusicAlbumReview";
  id: Scalars["ID"];
  title: Scalars["String"];
  creator?: Maybe<Scalars["String"]>;
  creatorUrl?: Maybe<Scalars["String"]>;
  purchaseUrl?: Maybe<Scalars["String"]>;
  image?: Maybe<BasicImage>;
  content?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
};

export type MusicAlbumReviewImageArgs = {
  width?: Maybe<Scalars["Int"]>;
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type Mutation = {
  __typename: "Mutation";
  anonymousNewsletterSignup?: Maybe<AnonymousNewsletterSignupPayload>;
  purgeArticle?: Maybe<Scalars["Boolean"]>;
  purgeHomepage?: Maybe<Scalars["Boolean"]>;
  purgeHomepageModule?: Maybe<Scalars["Boolean"]>;
};

export type MutationAnonymousNewsletterSignupArgs = {
  input: AnonymousNewsletterSignup;
};

export type MutationPurgeArticleArgs = {
  id: Scalars["ID"];
};

export type MutationPurgeHomepageModuleArgs = {
  id: Scalars["ID"];
};

export type NotesArticle = PromoItem & {
  __typename: "NotesArticle";
  id: Scalars["ID"];
  url: Scalars["String"];
  title: Scalars["InlineHtml"];
  dek?: Maybe<Scalars["InlineHtml"]>;
  riverImage?: Maybe<BasicImage>;
  authors: Array<Author>;
  datePublished?: Maybe<Scalars["DateTime"]>;
};

export type NotesArticleRiverImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type PageInfo = {
  __typename: "PageInfo";
  startCursor?: Maybe<Scalars["String"]>;
  endCursor?: Maybe<Scalars["String"]>;
  hasNextPage: Scalars["Boolean"];
  hasPreviousPage: Scalars["Boolean"];
};

export enum ParagraphSubtype {
  Dropcap = "DROPCAP",
}

export type PhotoArticle = PromoItem & {
  __typename: "PhotoArticle";
  id: Scalars["ID"];
  url: Scalars["String"];
  title: Scalars["InlineHtml"];
  dek?: Maybe<Scalars["InlineHtml"]>;
  riverImage?: Maybe<BasicImage>;
  authors: Array<Author>;
  datePublished?: Maybe<Scalars["DateTime"]>;
};

export type PhotoArticleRiverImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type PodcastEpisode = PromoItem & {
  __typename: "PodcastEpisode";
  id: Scalars["ID"];
  url: Scalars["String"];
  title: Scalars["InlineHtml"];
  dek?: Maybe<Scalars["InlineHtml"]>;
  kicker?: Maybe<Scalars["String"]>;
  riverImage?: Maybe<BasicImage>;
  authors: Array<Author>;
  datePublished?: Maybe<Scalars["DateTime"]>;
};

export type PodcastEpisodeRiverImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type PodcastSeries = List & {
  __typename: "PodcastSeries";
  id: Scalars["ID"];
  displayName: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
  river: RiverConnection;
  slug: Scalars["String"];
};

export type PodcastSeriesRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type PrimaryCategory = Channel | Category | EditorialProject;

export type PromoEdge = {
  __typename: "PromoEdge";
  id: Scalars["ID"];
  cursor: Scalars["String"];
  node: PromoItem;
};

export type PromoItem = {
  id: Scalars["ID"];
  url: Scalars["String"];
  title: Scalars["InlineHtml"];
  dek?: Maybe<Scalars["InlineHtml"]>;
  riverImage?: Maybe<BasicImage>;
  authors: Array<Author>;
  datePublished?: Maybe<Scalars["DateTime"]>;
};

export type PromoItemRiverImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type Query = {
  __typename: "Query";
  article: Article;
  channel: Channel;
  author: Author;
  category: Category;
  breakingNews?: Maybe<BreakingNews>;
  mostPopular: CuratedGroup;
  relatedContent?: Maybe<RelatedContent>;
  recircRecommendation?: Maybe<RecircRecommendation>;
  relatedVideos?: Maybe<RelatedVideos>;
  latest: Latest;
  magazineIssues: MagazineIssues;
  mobileSections: Array<List>;
  curatedGroup?: Maybe<CuratedGroup>;
  curatedAuthorGroup: CuratedAuthorGroup;
  homepageModule?: Maybe<HomepageModule>;
  activePodcastSeries: Array<PodcastSeries>;
  editorialProject?: Maybe<EditorialProject>;
};

export type QueryArticleArgs = {
  id: Scalars["ID"];
  preview?: Maybe<Scalars["String"]>;
};

export type QueryChannelArgs = {
  slug: Scalars["String"];
};

export type QueryAuthorArgs = {
  slug: Scalars["String"];
};

export type QueryCategoryArgs = {
  id: Scalars["ID"];
};

export type QueryRelatedContentArgs = {
  id: Scalars["ID"];
  preview?: Maybe<Scalars["String"]>;
};

export type QueryRecircRecommendationArgs = {
  id: Scalars["ID"];
  service: RecircServiceName;
  algorithm?: Maybe<Scalars["String"]>;
};

export type QueryRelatedVideosArgs = {
  id: Scalars["ID"];
  preview?: Maybe<Scalars["String"]>;
};

export type QueryCuratedGroupArgs = {
  slug: Scalars["String"];
};

export type QueryCuratedAuthorGroupArgs = {
  slug: Scalars["String"];
};

export type QueryHomepageModuleArgs = {
  slug: Scalars["String"];
  version: Scalars["String"];
};

export type QueryEditorialProjectArgs = {
  slug: Scalars["String"];
};

export type RecircRecommendation = List & {
  __typename: "RecircRecommendation";
  id: Scalars["ID"];
  slug: Scalars["String"];
  displayName: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
  serviceUsed: Scalars["String"];
  river: RiverConnection;
};

export type RecircRecommendationRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export enum RecircServiceName {
  Parsely = "PARSELY",
  Datascience = "DATASCIENCE",
  Ollie = "OLLIE",
}

export type RelatedContent = List & {
  __typename: "RelatedContent";
  id: Scalars["ID"];
  displayName: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
  river: RiverConnection;
  slug: Scalars["String"];
};

export type RelatedContentRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type RelatedVideos = List & {
  __typename: "RelatedVideos";
  id: Scalars["ID"];
  displayName: Scalars["String"];
  url?: Maybe<Scalars["String"]>;
  river: RiverConnection;
  slug: Scalars["String"];
};

export type RelatedVideosRiverArgs = {
  first?: Maybe<Scalars["Int"]>;
  after?: Maybe<Scalars["String"]>;
  last?: Maybe<Scalars["Int"]>;
  before?: Maybe<Scalars["String"]>;
  excludes?: Maybe<Array<Scalars["ID"]>>;
};

export type Review = {
  id: Scalars["ID"];
  title: Scalars["String"];
  creator?: Maybe<Scalars["String"]>;
  creatorUrl?: Maybe<Scalars["String"]>;
  purchaseUrl?: Maybe<Scalars["String"]>;
  image?: Maybe<BasicImage>;
  content?: Maybe<Scalars["String"]>;
  url?: Maybe<Scalars["String"]>;
};

export type ReviewImageArgs = {
  width?: Maybe<Scalars["Int"]>;
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type RiverConnection = {
  __typename: "RiverConnection";
  pageInfo: PageInfo;
  edges: Array<PromoEdge>;
};

export type SocialMedia = {
  __typename: "SocialMedia";
  platform: SocialMediaPlatform;
  url: Scalars["String"];
};

export enum SocialMediaPlatform {
  Email = "EMAIL",
  Facebook = "FACEBOOK",
  Twitter = "TWITTER",
}

export type Video = {
  attributionText?: Maybe<Scalars["String"]>;
  captionText?: Maybe<Scalars["InlineHtml"]>;
  formats: Array<VideoFormat>;
  height?: Maybe<Scalars["Int"]>;
  width?: Maybe<Scalars["Int"]>;
  poster?: Maybe<BasicCrop>;
};

export type VideoPosterArgs = {
  width: Scalars["Int"];
  height?: Maybe<Scalars["Int"]>;
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export type VideoArticle = PromoItem & {
  __typename: "VideoArticle";
  id: Scalars["ID"];
  url: Scalars["String"];
  title: Scalars["InlineHtml"];
  dek?: Maybe<Scalars["InlineHtml"]>;
  riverImage?: Maybe<BasicImage>;
  authors: Array<Author>;
  datePublished?: Maybe<Scalars["DateTime"]>;
  embedUrl: Scalars["String"];
};

export type VideoArticleRiverImageArgs = {
  width: Scalars["Int"];
  height: Scalars["Int"];
  sizes?: Maybe<Array<Scalars["String"]>>;
};

export enum VideoEncoding {
  H264 = "H264",
  Vp9 = "VP9",
  Hevc = "HEVC",
}

export type VideoFormat = {
  __typename: "VideoFormat";
  encoding?: Maybe<VideoEncoding>;
  url?: Maybe<Scalars["String"]>;
};

export type WatsonInfo = {
  __typename: "WatsonInfo";
  topCategory: WatsonTopCategory;
  categories: Array<Scalars["String"]>;
  concepts: Array<Scalars["String"]>;
  entities: Array<Scalars["String"]>;
  keywords: Array<Scalars["String"]>;
};

export type WatsonTopCategory = {
  __typename: "WatsonTopCategory";
  full: Scalars["String"];
  one?: Maybe<Scalars["String"]>;
  two?: Maybe<Scalars["String"]>;
  three?: Maybe<Scalars["String"]>;
  four?: Maybe<Scalars["String"]>;
};

export type BreakingNewsQueryVariables = Exact<{ [key: string]: never }>;

export type BreakingNewsQuery = {
  __typename: "Query";
  breakingNews?: Maybe<{
    __typename: "BreakingNews";
    id: string;
    kicker?: Maybe<string>;
    text: string;
    url?: Maybe<string>;
    theme: BreakingNewsTheme;
  }>;
};

export type AnonymousNewsletterSignupMutationVariables = Exact<{
  input: AnonymousNewsletterSignup;
}>;

export type AnonymousNewsletterSignupMutation = {
  __typename: "Mutation";
  anonymousNewsletterSignup?: Maybe<{
    __typename: "AnonymousNewsletterSignupPayload";
    existingUser?: Maybe<boolean>;
  }>;
};

export type NotFoundMostPopularAuthorFragment = {
  __typename: "Author";
  id: string;
  displayName: string;
  url: string;
};

type NotFoundMostPopularPromoItem_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  id: string;
  url: string;
  title: string;
  authors: Array<{ __typename: "Author" } & NotFoundMostPopularAuthorFragment>;
};

type NotFoundMostPopularPromoItem_CuratedArticle_Fragment = {
  __typename: "CuratedArticle";
  id: string;
  url: string;
  title: string;
  authors: Array<{ __typename: "Author" } & NotFoundMostPopularAuthorFragment>;
};

type NotFoundMostPopularPromoItem_HomepagePromoItem_Fragment = {
  __typename: "HomepagePromoItem";
  id: string;
  url: string;
  title: string;
  authors: Array<{ __typename: "Author" } & NotFoundMostPopularAuthorFragment>;
};

type NotFoundMostPopularPromoItem_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  id: string;
  url: string;
  title: string;
  authors: Array<{ __typename: "Author" } & NotFoundMostPopularAuthorFragment>;
};

type NotFoundMostPopularPromoItem_MagazineIssue_Fragment = {
  __typename: "MagazineIssue";
  id: string;
  url: string;
  title: string;
  authors: Array<{ __typename: "Author" } & NotFoundMostPopularAuthorFragment>;
};

type NotFoundMostPopularPromoItem_NotesArticle_Fragment = {
  __typename: "NotesArticle";
  id: string;
  url: string;
  title: string;
  authors: Array<{ __typename: "Author" } & NotFoundMostPopularAuthorFragment>;
};

type NotFoundMostPopularPromoItem_PhotoArticle_Fragment = {
  __typename: "PhotoArticle";
  id: string;
  url: string;
  title: string;
  authors: Array<{ __typename: "Author" } & NotFoundMostPopularAuthorFragment>;
};

type NotFoundMostPopularPromoItem_PodcastEpisode_Fragment = {
  __typename: "PodcastEpisode";
  id: string;
  url: string;
  title: string;
  authors: Array<{ __typename: "Author" } & NotFoundMostPopularAuthorFragment>;
};

type NotFoundMostPopularPromoItem_VideoArticle_Fragment = {
  __typename: "VideoArticle";
  id: string;
  url: string;
  title: string;
  authors: Array<{ __typename: "Author" } & NotFoundMostPopularAuthorFragment>;
};

export type NotFoundMostPopularPromoItemFragment =
  | NotFoundMostPopularPromoItem_BlogArticle_Fragment
  | NotFoundMostPopularPromoItem_CuratedArticle_Fragment
  | NotFoundMostPopularPromoItem_HomepagePromoItem_Fragment
  | NotFoundMostPopularPromoItem_MagazineArticle_Fragment
  | NotFoundMostPopularPromoItem_MagazineIssue_Fragment
  | NotFoundMostPopularPromoItem_NotesArticle_Fragment
  | NotFoundMostPopularPromoItem_PhotoArticle_Fragment
  | NotFoundMostPopularPromoItem_PodcastEpisode_Fragment
  | NotFoundMostPopularPromoItem_VideoArticle_Fragment;

export type NotFoundMostPopularFragment = {
  __typename: "CuratedGroup";
  river: {
    __typename: "RiverConnection";
    edges: Array<{
      __typename: "PromoEdge";
      cursor: string;
      node:
        | ({
            __typename: "BlogArticle";
          } & NotFoundMostPopularPromoItem_BlogArticle_Fragment)
        | ({
            __typename: "CuratedArticle";
          } & NotFoundMostPopularPromoItem_CuratedArticle_Fragment)
        | ({
            __typename: "HomepagePromoItem";
          } & NotFoundMostPopularPromoItem_HomepagePromoItem_Fragment)
        | ({
            __typename: "MagazineArticle";
          } & NotFoundMostPopularPromoItem_MagazineArticle_Fragment)
        | ({
            __typename: "MagazineIssue";
          } & NotFoundMostPopularPromoItem_MagazineIssue_Fragment)
        | ({
            __typename: "NotesArticle";
          } & NotFoundMostPopularPromoItem_NotesArticle_Fragment)
        | ({
            __typename: "PhotoArticle";
          } & NotFoundMostPopularPromoItem_PhotoArticle_Fragment)
        | ({
            __typename: "PodcastEpisode";
          } & NotFoundMostPopularPromoItem_PodcastEpisode_Fragment)
        | ({
            __typename: "VideoArticle";
          } & NotFoundMostPopularPromoItem_VideoArticle_Fragment);
    }>;
  };
};

export type NotFoundMostPopularQueryVariables = Exact<{ [key: string]: never }>;

export type NotFoundMostPopularQuery = {
  __typename: "Query";
  mostPopular: { __typename: "CuratedGroup" } & NotFoundMostPopularFragment;
};

type AboutTheAuthors_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  authors: Array<{
    __typename: "Author";
    id: string;
    url: string;
    displayName: string;
    biography?: Maybe<{ __typename: "Biography"; default?: Maybe<string> }>;
  }>;
};

type AboutTheAuthors_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  authors: Array<{
    __typename: "Author";
    id: string;
    url: string;
    displayName: string;
    biography?: Maybe<{ __typename: "Biography"; default?: Maybe<string> }>;
  }>;
};

export type AboutTheAuthorsFragment =
  | AboutTheAuthors_BlogArticle_Fragment
  | AboutTheAuthors_MagazineArticle_Fragment;

export type ArticleQueryVariables = Exact<{
  id: Scalars["ID"];
  preview?: Maybe<Scalars["String"]>;
}>;

export type ArticleQuery = {
  __typename: "Query";
  article:
    | ({
        __typename: "BlogArticle";
        id: string;
        isTnfCompatible: boolean;
        datePublished?: Maybe<string>;
        title: string;
        slug: string;
        wordCount: number;
        layout: ArticleLayout;
        isFreelance?: Maybe<boolean>;
        isPython3?: Maybe<boolean>;
        preview?: Maybe<string>;
        watsonInfo?: Maybe<{
          __typename: "WatsonInfo";
          categories: Array<string>;
          topCategory: {
            __typename: "WatsonTopCategory";
            full: string;
            one?: Maybe<string>;
            two?: Maybe<string>;
            three?: Maybe<string>;
            four?: Maybe<string>;
          };
        }>;
        grapeshot?: Maybe<{ __typename: "Grapeshot"; segments: Array<string> }>;
        editorialMotivation?: Maybe<{
          __typename: "EditorialMotivation";
          slug: string;
        }>;
        editorialProject?: Maybe<
          {
            __typename: "EditorialProject";
            slug: string;
            displayName: string;
          } & ArticleBentoRecircSwanFragment &
            ArticleFoundationLineSwanFragment
        >;
        leadArt?: Maybe<
          | ({
              __typename: "LeadArtImage";
            } & ArticleLeadArtSwan_LeadArtImage_Fragment)
          | ({
              __typename: "LeadArtImageLarge";
            } & ArticleLeadArtSwan_LeadArtImageLarge_Fragment)
          | ({
              __typename: "LeadArtEmbed";
            } & ArticleLeadArtSwan_LeadArtEmbed_Fragment)
          | ({
              __typename: "Cinemagraph";
            } & ArticleLeadArtSwan_Cinemagraph_Fragment)
        >;
        embeds: Array<{ __typename: "Embed"; type: string; src: string }>;
        primaryChannel?: Maybe<{
          __typename: "Channel";
          slug: string;
          displayName: string;
        }>;
        primaryCategory?: Maybe<
          | { __typename: "Channel"; slug: string }
          | { __typename: "Category"; slug: string }
          | { __typename: "EditorialProject"; slug: string }
        >;
        categories: Array<{ __typename: "Category"; slug: string }>;
        channels: Array<{ __typename: "Channel"; slug: string }>;
        editorsNote?: Maybe<
          { __typename: "EditorsNote" } & EditorsNoteSwanFragment
        >;
        advertisingInfo?: Maybe<{
          __typename: "AdvertisingInfo";
          disableHouseAd: boolean;
        }>;
      } & ArticleMetadata_BlogArticle_Fragment &
        ArticleRubric_BlogArticle_Fragment &
        ArticleTitle_BlogArticle_Fragment &
        ArticleSwanDek_BlogArticle_Fragment &
        ArticleTimestamp_BlogArticle_Fragment &
        ArticleBioSwan_BlogArticle_Fragment &
        AboutTheAuthors_BlogArticle_Fragment &
        ArticleBylines_BlogArticle_Fragment &
        ArticleJsonLdData_BlogArticle_Fragment &
        ArticleShare_BlogArticle_Fragment &
        ArticleBodyContent_BlogArticle_Fragment)
    | ({
        __typename: "MagazineArticle";
        id: string;
        isTnfCompatible: boolean;
        datePublished?: Maybe<string>;
        title: string;
        slug: string;
        wordCount: number;
        layout: ArticleLayout;
        isFreelance?: Maybe<boolean>;
        isPython3?: Maybe<boolean>;
        preview?: Maybe<string>;
        issue: { __typename: "MagazineIssue"; issueName: string; slug: string };
        watsonInfo?: Maybe<{
          __typename: "WatsonInfo";
          categories: Array<string>;
          topCategory: {
            __typename: "WatsonTopCategory";
            full: string;
            one?: Maybe<string>;
            two?: Maybe<string>;
            three?: Maybe<string>;
            four?: Maybe<string>;
          };
        }>;
        grapeshot?: Maybe<{ __typename: "Grapeshot"; segments: Array<string> }>;
        editorialMotivation?: Maybe<{
          __typename: "EditorialMotivation";
          slug: string;
        }>;
        editorialProject?: Maybe<
          {
            __typename: "EditorialProject";
            slug: string;
            displayName: string;
          } & ArticleBentoRecircSwanFragment &
            ArticleFoundationLineSwanFragment
        >;
        leadArt?: Maybe<
          | ({
              __typename: "LeadArtImage";
            } & ArticleLeadArtSwan_LeadArtImage_Fragment)
          | ({
              __typename: "LeadArtImageLarge";
            } & ArticleLeadArtSwan_LeadArtImageLarge_Fragment)
          | ({
              __typename: "LeadArtEmbed";
            } & ArticleLeadArtSwan_LeadArtEmbed_Fragment)
          | ({
              __typename: "Cinemagraph";
            } & ArticleLeadArtSwan_Cinemagraph_Fragment)
        >;
        embeds: Array<{ __typename: "Embed"; type: string; src: string }>;
        primaryChannel?: Maybe<{
          __typename: "Channel";
          slug: string;
          displayName: string;
        }>;
        primaryCategory?: Maybe<
          | { __typename: "Channel"; slug: string }
          | { __typename: "Category"; slug: string }
          | { __typename: "EditorialProject"; slug: string }
        >;
        categories: Array<{ __typename: "Category"; slug: string }>;
        channels: Array<{ __typename: "Channel"; slug: string }>;
        editorsNote?: Maybe<
          { __typename: "EditorsNote" } & EditorsNoteSwanFragment
        >;
        advertisingInfo?: Maybe<{
          __typename: "AdvertisingInfo";
          disableHouseAd: boolean;
        }>;
      } & ArticleMetadata_MagazineArticle_Fragment &
        ArticleRubric_MagazineArticle_Fragment &
        ArticleTitle_MagazineArticle_Fragment &
        ArticleSwanDek_MagazineArticle_Fragment &
        ArticleTimestamp_MagazineArticle_Fragment &
        ArticleBioSwan_MagazineArticle_Fragment &
        AboutTheAuthors_MagazineArticle_Fragment &
        ArticleBylines_MagazineArticle_Fragment &
        ArticleJsonLdData_MagazineArticle_Fragment &
        ArticleShare_MagazineArticle_Fragment &
        ArticleBodyContent_MagazineArticle_Fragment);
};

export type ArticleRecircAuthorFragment = {
  __typename: "Author";
  url: string;
  displayName: string;
  id: string;
  slug: string;
};

export type ArticleRecircFragment = {
  __typename: "RiverConnection";
  edges: Array<{
    __typename: "PromoEdge";
    node:
      | {
          __typename: "BlogArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & ArticleRecircAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "CuratedArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & ArticleRecircAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "HomepagePromoItem";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & ArticleRecircAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "MagazineArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & ArticleRecircAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "MagazineIssue";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & ArticleRecircAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "NotesArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & ArticleRecircAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "PhotoArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & ArticleRecircAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "PodcastEpisode";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & ArticleRecircAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "VideoArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & ArticleRecircAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        };
  }>;
};

export type ArticleBentoRecircSwanFragment = {
  __typename: "EditorialProject";
  displayName: string;
  url: string;
  accentColor?: Maybe<string>;
  textColor?: Maybe<string>;
  presentedByUrl?: Maybe<string>;
  presentedByDisplayName?: Maybe<string>;
  river: { __typename: "RiverConnection" } & ArticleRecircFragment;
};

export type AuthorBioSwanFragment = {
  __typename: "Author";
  id: string;
  displayName: string;
  url: string;
  biography?: Maybe<{ __typename: "Biography"; default?: Maybe<string> }>;
  socialMedia: Array<{
    __typename: "SocialMedia";
    platform: SocialMediaPlatform;
    url: string;
  }>;
};

type ArticleBioSwan_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  reviews: Array<
    | { __typename: "BookReview" }
    | { __typename: "EpisodeReview" }
    | { __typename: "MovieReview" }
    | { __typename: "MusicAlbumReview" }
  >;
  authors: Array<{ __typename: "Author" } & AuthorBioSwanFragment>;
};

type ArticleBioSwan_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  reviews: Array<
    | { __typename: "BookReview" }
    | { __typename: "EpisodeReview" }
    | { __typename: "MovieReview" }
    | { __typename: "MusicAlbumReview" }
  >;
  authors: Array<{ __typename: "Author" } & AuthorBioSwanFragment>;
};

export type ArticleBioSwanFragment =
  | ArticleBioSwan_BlogArticle_Fragment
  | ArticleBioSwan_MagazineArticle_Fragment;

type ArticleBodyContent_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  content: Array<
    | ({ __typename: "ArticleParagraphContent" } & ArticleParagraphFragment)
    | ({ __typename: "ArticleHeading" } & ArticleHeadingFragment)
    | ({
        __typename: "ArticleRelatedContentLink";
      } & ArticleRelatedContentLinkFragment)
    | ({ __typename: "ArticlePullquote" } & ArticlePullquoteFragment)
    | ({ __typename: "ArticleInlineImage" } & ArticleInlineImageFragment)
    | ({
        __typename: "ArticleWellInlineImage";
      } & ArticleWellInlineImageFragment)
    | ({
        __typename: "ArticleOverflowInlineImage";
      } & ArticleOverflowInlineImageFragment)
    | ({
        __typename: "ArticleRelatedContentModule";
      } & ArticleRelatedContentModuleFragment)
    | ({ __typename: "ArticleLegacyHtml" } & ArticleLegacyHtmlFragment)
    | { __typename: "ArticleAdPlaceholder" }
  >;
  categories: Array<{ __typename: "Category"; slug: string }>;
};

type ArticleBodyContent_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  content: Array<
    | ({ __typename: "ArticleParagraphContent" } & ArticleParagraphFragment)
    | ({ __typename: "ArticleHeading" } & ArticleHeadingFragment)
    | ({
        __typename: "ArticleRelatedContentLink";
      } & ArticleRelatedContentLinkFragment)
    | ({ __typename: "ArticlePullquote" } & ArticlePullquoteFragment)
    | ({ __typename: "ArticleInlineImage" } & ArticleInlineImageFragment)
    | ({
        __typename: "ArticleWellInlineImage";
      } & ArticleWellInlineImageFragment)
    | ({
        __typename: "ArticleOverflowInlineImage";
      } & ArticleOverflowInlineImageFragment)
    | ({
        __typename: "ArticleRelatedContentModule";
      } & ArticleRelatedContentModuleFragment)
    | ({ __typename: "ArticleLegacyHtml" } & ArticleLegacyHtmlFragment)
    | { __typename: "ArticleAdPlaceholder" }
  >;
  categories: Array<{ __typename: "Category"; slug: string }>;
};

export type ArticleBodyContentFragment =
  | ArticleBodyContent_BlogArticle_Fragment
  | ArticleBodyContent_MagazineArticle_Fragment;

export type BooksFooterQueryVariables = Exact<{
  id: Scalars["ID"];
  preview?: Maybe<Scalars["String"]>;
}>;

export type BooksFooterQuery = {
  __typename: "Query";
  article:
    | {
        __typename: "BlogArticle";
        reviews: Array<
          | {
              __typename: "BookReview";
              asin?: Maybe<string>;
              bookshopIsbn?: Maybe<string>;
              publisher?: Maybe<string>;
              title: string;
              creator?: Maybe<string>;
            }
          | {
              __typename: "EpisodeReview";
              title: string;
              creator?: Maybe<string>;
            }
          | {
              __typename: "MovieReview";
              title: string;
              creator?: Maybe<string>;
            }
          | {
              __typename: "MusicAlbumReview";
              title: string;
              creator?: Maybe<string>;
            }
        >;
      }
    | {
        __typename: "MagazineArticle";
        reviews: Array<
          | {
              __typename: "BookReview";
              asin?: Maybe<string>;
              bookshopIsbn?: Maybe<string>;
              publisher?: Maybe<string>;
              title: string;
              creator?: Maybe<string>;
            }
          | {
              __typename: "EpisodeReview";
              title: string;
              creator?: Maybe<string>;
            }
          | {
              __typename: "MovieReview";
              title: string;
              creator?: Maybe<string>;
            }
          | {
              __typename: "MusicAlbumReview";
              title: string;
              creator?: Maybe<string>;
            }
        >;
      };
};

export type BooksQueryVariables = Exact<{
  id: Scalars["ID"];
  preview?: Maybe<Scalars["String"]>;
}>;

export type BooksQuery = {
  __typename: "Query";
  article:
    | {
        __typename: "BlogArticle";
        reviews: Array<
          | {
              __typename: "BookReview";
              bookshopIsbn?: Maybe<string>;
              asin?: Maybe<string>;
              publisher?: Maybe<string>;
              title: string;
              creator?: Maybe<string>;
              image?: Maybe<{
                __typename: "BasicImage";
                url: string;
                width: number;
                height: number;
                srcSet: string;
                altText: string;
              }>;
            }
          | {
              __typename: "EpisodeReview";
              title: string;
              creator?: Maybe<string>;
            }
          | {
              __typename: "MovieReview";
              title: string;
              creator?: Maybe<string>;
            }
          | {
              __typename: "MusicAlbumReview";
              title: string;
              creator?: Maybe<string>;
            }
        >;
      }
    | {
        __typename: "MagazineArticle";
        reviews: Array<
          | {
              __typename: "BookReview";
              bookshopIsbn?: Maybe<string>;
              asin?: Maybe<string>;
              publisher?: Maybe<string>;
              title: string;
              creator?: Maybe<string>;
              image?: Maybe<{
                __typename: "BasicImage";
                url: string;
                width: number;
                height: number;
                srcSet: string;
                altText: string;
              }>;
            }
          | {
              __typename: "EpisodeReview";
              title: string;
              creator?: Maybe<string>;
            }
          | {
              __typename: "MovieReview";
              title: string;
              creator?: Maybe<string>;
            }
          | {
              __typename: "MusicAlbumReview";
              title: string;
              creator?: Maybe<string>;
            }
        >;
      };
};

export type ArticleBylinesAuthorFragment = {
  __typename: "Author";
  id: string;
  url: string;
  displayName: string;
};

type ArticleBylines_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  secondaryByline?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & ArticleBylinesAuthorFragment>;
};

type ArticleBylines_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  secondaryByline?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & ArticleBylinesAuthorFragment>;
};

export type ArticleBylinesFragment =
  | ArticleBylines_BlogArticle_Fragment
  | ArticleBylines_MagazineArticle_Fragment;

type ArticleSwanDek_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  dek?: Maybe<string>;
};

type ArticleSwanDek_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  dek?: Maybe<string>;
};

export type ArticleSwanDekFragment =
  | ArticleSwanDek_BlogArticle_Fragment
  | ArticleSwanDek_MagazineArticle_Fragment;

export type ArticleFoundationLineSwanFragment = {
  __typename: "EditorialProject";
  foundationLineArticle?: Maybe<string>;
};

export type ArticleHeadingFragment = {
  __typename: "ArticleHeading";
  idAttr: string;
  innerHtml: string;
  headingSubtype: ArticleHeadingLevel;
};

export type ArticleInlineImageFragment = {
  __typename: "ArticleInlineImage";
  alignment?: Maybe<ArticleInlineImageAlignment>;
  clickthroughUrl: string;
} & ArticleInlineImageFigure_ArticleInlineImage_Fragment;

type ArticleInlineImageFigure_ArticleInlineImage_Fragment = {
  __typename: "ArticleInlineImage";
  url: string;
  width: number;
  height: number;
  srcSet: string;
  attributionText: string;
  altText: string;
  captionText: string;
};

type ArticleInlineImageFigure_ArticleOverflowInlineImage_Fragment = {
  __typename: "ArticleOverflowInlineImage";
  url: string;
  width: number;
  height: number;
  srcSet: string;
  attributionText: string;
  altText: string;
  captionText: string;
};

type ArticleInlineImageFigure_ArticleWellInlineImage_Fragment = {
  __typename: "ArticleWellInlineImage";
  url: string;
  width: number;
  height: number;
  srcSet: string;
  attributionText: string;
  altText: string;
  captionText: string;
};

type ArticleInlineImageFigure_BasicImage_Fragment = {
  __typename: "BasicImage";
  url: string;
  width: number;
  height: number;
  srcSet: string;
  attributionText: string;
  altText: string;
  captionText: string;
};

export type ArticleInlineImageFigureFragment =
  | ArticleInlineImageFigure_ArticleInlineImage_Fragment
  | ArticleInlineImageFigure_ArticleOverflowInlineImage_Fragment
  | ArticleInlineImageFigure_ArticleWellInlineImage_Fragment
  | ArticleInlineImageFigure_BasicImage_Fragment;

type ArticleLeadArtSwan_LeadArtImage_Fragment = {
  __typename: "LeadArtImage";
  image?: Maybe<{
    __typename: "BasicImage";
    url: string;
    width: number;
    height: number;
    srcSet: string;
    captionText: string;
    attributionText: string;
    attributionUrl: string;
    altText: string;
  }>;
};

type ArticleLeadArtSwan_LeadArtImageLarge_Fragment = {
  __typename: "LeadArtImageLarge";
  image?: Maybe<{
    __typename: "BasicImage";
    url: string;
    width: number;
    height: number;
    srcSet: string;
    captionText: string;
    attributionText: string;
    attributionUrl: string;
    altText: string;
  }>;
};

type ArticleLeadArtSwan_LeadArtEmbed_Fragment = {
  __typename: "LeadArtEmbed";
  src: string;
  width: string;
  height: string;
  caption: string;
};

type ArticleLeadArtSwan_Cinemagraph_Fragment = {
  __typename: "Cinemagraph";
  attributionText?: Maybe<string>;
  captionText?: Maybe<string>;
  formats: Array<{
    __typename: "VideoFormat";
    encoding?: Maybe<VideoEncoding>;
    url?: Maybe<string>;
  }>;
  poster?: Maybe<{
    __typename: "BasicCrop";
    width: number;
    height: number;
    url: string;
  }>;
};

export type ArticleLeadArtSwanFragment =
  | ArticleLeadArtSwan_LeadArtImage_Fragment
  | ArticleLeadArtSwan_LeadArtImageLarge_Fragment
  | ArticleLeadArtSwan_LeadArtEmbed_Fragment
  | ArticleLeadArtSwan_Cinemagraph_Fragment;

export type ArticleLegacyHtmlFragment = {
  __typename: "ArticleLegacyHtml";
  tagName: LegacyHtmlTagName;
  idAttr: string;
  className: string;
  style: string;
  innerHtml: string;
};

export type ArticleSwanMostPopularAuthorFragment = {
  __typename: "Author";
  id: string;
  displayName: string;
  slug: string;
  url: string;
};

type ArticleSwanMostPopularPromoItem_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<
    { __typename: "Author" } & ArticleSwanMostPopularAuthorFragment
  >;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleSwanMostPopularPromoItem_CuratedArticle_Fragment = {
  __typename: "CuratedArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<
    { __typename: "Author" } & ArticleSwanMostPopularAuthorFragment
  >;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleSwanMostPopularPromoItem_HomepagePromoItem_Fragment = {
  __typename: "HomepagePromoItem";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<
    { __typename: "Author" } & ArticleSwanMostPopularAuthorFragment
  >;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleSwanMostPopularPromoItem_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<
    { __typename: "Author" } & ArticleSwanMostPopularAuthorFragment
  >;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleSwanMostPopularPromoItem_MagazineIssue_Fragment = {
  __typename: "MagazineIssue";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<
    { __typename: "Author" } & ArticleSwanMostPopularAuthorFragment
  >;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleSwanMostPopularPromoItem_NotesArticle_Fragment = {
  __typename: "NotesArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<
    { __typename: "Author" } & ArticleSwanMostPopularAuthorFragment
  >;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleSwanMostPopularPromoItem_PhotoArticle_Fragment = {
  __typename: "PhotoArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<
    { __typename: "Author" } & ArticleSwanMostPopularAuthorFragment
  >;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleSwanMostPopularPromoItem_PodcastEpisode_Fragment = {
  __typename: "PodcastEpisode";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<
    { __typename: "Author" } & ArticleSwanMostPopularAuthorFragment
  >;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleSwanMostPopularPromoItem_VideoArticle_Fragment = {
  __typename: "VideoArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<
    { __typename: "Author" } & ArticleSwanMostPopularAuthorFragment
  >;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

export type ArticleSwanMostPopularPromoItemFragment =
  | ArticleSwanMostPopularPromoItem_BlogArticle_Fragment
  | ArticleSwanMostPopularPromoItem_CuratedArticle_Fragment
  | ArticleSwanMostPopularPromoItem_HomepagePromoItem_Fragment
  | ArticleSwanMostPopularPromoItem_MagazineArticle_Fragment
  | ArticleSwanMostPopularPromoItem_MagazineIssue_Fragment
  | ArticleSwanMostPopularPromoItem_NotesArticle_Fragment
  | ArticleSwanMostPopularPromoItem_PhotoArticle_Fragment
  | ArticleSwanMostPopularPromoItem_PodcastEpisode_Fragment
  | ArticleSwanMostPopularPromoItem_VideoArticle_Fragment;

export type ArticleSwanMostPopularFragment = {
  __typename: "CuratedGroup";
  displayName: string;
  river: {
    __typename: "RiverConnection";
    edges: Array<{
      __typename: "PromoEdge";
      cursor: string;
      node:
        | ({
            __typename: "BlogArticle";
          } & ArticleSwanMostPopularPromoItem_BlogArticle_Fragment)
        | ({
            __typename: "CuratedArticle";
          } & ArticleSwanMostPopularPromoItem_CuratedArticle_Fragment)
        | ({
            __typename: "HomepagePromoItem";
          } & ArticleSwanMostPopularPromoItem_HomepagePromoItem_Fragment)
        | ({
            __typename: "MagazineArticle";
          } & ArticleSwanMostPopularPromoItem_MagazineArticle_Fragment)
        | ({
            __typename: "MagazineIssue";
          } & ArticleSwanMostPopularPromoItem_MagazineIssue_Fragment)
        | ({
            __typename: "NotesArticle";
          } & ArticleSwanMostPopularPromoItem_NotesArticle_Fragment)
        | ({
            __typename: "PhotoArticle";
          } & ArticleSwanMostPopularPromoItem_PhotoArticle_Fragment)
        | ({
            __typename: "PodcastEpisode";
          } & ArticleSwanMostPopularPromoItem_PodcastEpisode_Fragment)
        | ({
            __typename: "VideoArticle";
          } & ArticleSwanMostPopularPromoItem_VideoArticle_Fragment);
    }>;
  };
};

export type ArticleSwanMostPopularQueryVariables = Exact<{
  [key: string]: never;
}>;

export type ArticleSwanMostPopularQuery = {
  __typename: "Query";
  mostPopular: { __typename: "CuratedGroup" } & ArticleSwanMostPopularFragment;
};

export type ArticleOverflowInlineImageFragment = {
  __typename: "ArticleOverflowInlineImage";
  clickthroughUrl: string;
  crop?: Maybe<{
    __typename: "BasicCrop";
    url: string;
    width: number;
    height: number;
    srcSet: string;
  }>;
} & ArticleInlineImageFigure_ArticleOverflowInlineImage_Fragment;

export type ArticleParagraphFragment = {
  __typename: "ArticleParagraphContent";
  idAttr: string;
  subtype?: Maybe<ParagraphSubtype>;
  innerHtml: string;
};

export type ArticlePullquoteFragment = {
  __typename: "ArticlePullquote";
  idAttr: string;
  innerHtml: string;
};

export type ChannelRelatedContentQueryVariables = Exact<{
  slug: Scalars["String"];
  id: Scalars["ID"];
}>;

export type ChannelRelatedContentQuery = {
  __typename: "Query";
  channel: {
    __typename: "Channel";
    displayName: string;
    river: { __typename: "RiverConnection" } & RelatedContentRiverFragment;
  };
};

export type ArticleRelatedContentLinkFragment = {
  __typename: "ArticleRelatedContentLink";
  idAttr: string;
  innerHtml: string;
};

export type RelatedContentAuthorFragment = {
  __typename: "Author";
  url: string;
  displayName: string;
  id: string;
  slug: string;
};

export type RelatedContentRiverFragment = {
  __typename: "RiverConnection";
  edges: Array<{
    __typename: "PromoEdge";
    node:
      | {
          __typename: "BlogArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & RelatedContentAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "CuratedArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & RelatedContentAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "HomepagePromoItem";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & RelatedContentAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "MagazineArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & RelatedContentAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "MagazineIssue";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & RelatedContentAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "NotesArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & RelatedContentAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "PhotoArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & RelatedContentAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "PodcastEpisode";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & RelatedContentAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        }
      | {
          __typename: "VideoArticle";
          url: string;
          title: string;
          authors: Array<
            { __typename: "Author" } & RelatedContentAuthorFragment
          >;
          riverImage?: Maybe<{
            __typename: "BasicImage";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
            altText: string;
          }>;
        };
  }>;
};

export type MagazineRelatedContentQueryVariables = Exact<{
  id: Scalars["ID"];
  preview?: Maybe<Scalars["String"]>;
}>;

export type MagazineRelatedContentQuery = {
  __typename: "Query";
  article:
    | { __typename: "BlogArticle" }
    | {
        __typename: "MagazineArticle";
        issue: {
          __typename: "MagazineIssue";
          issueName: string;
          url: string;
          cover?: Maybe<{
            __typename: "BasicCrop";
            id: string;
            url: string;
            srcSet: string;
            width: number;
            height: number;
          }>;
        };
      };
};

export type ArticleRelatedContentModuleFragment = {
  __typename: "ArticleRelatedContentModule";
  contentType: ArticleRelatedContentType;
};

export type RecommendedRelatedContentQueryVariables = Exact<{
  id: Scalars["ID"];
  service: RecircServiceName;
  algorithm?: Maybe<Scalars["String"]>;
}>;

export type RecommendedRelatedContentQuery = {
  __typename: "Query";
  recircRecommendation?: Maybe<{
    __typename: "RecircRecommendation";
    displayName: string;
    serviceUsed: string;
    river: { __typename: "RiverConnection" } & RelatedContentRiverFragment;
  }>;
};

export type RelatedVideosQueryVariables = Exact<{
  id: Scalars["ID"];
  preview?: Maybe<Scalars["String"]>;
}>;

export type RelatedVideosQuery = {
  __typename: "Query";
  relatedVideos?: Maybe<{
    __typename: "RelatedVideos";
    river: {
      __typename: "RiverConnection";
      edges: Array<{
        __typename: "PromoEdge";
        node:
          | { __typename: "BlogArticle" }
          | { __typename: "CuratedArticle" }
          | { __typename: "HomepagePromoItem" }
          | { __typename: "MagazineArticle" }
          | { __typename: "MagazineIssue" }
          | { __typename: "NotesArticle" }
          | { __typename: "PhotoArticle" }
          | { __typename: "PodcastEpisode" }
          | { __typename: "VideoArticle"; embedUrl: string; title: string };
      }>;
    };
  }>;
};

type ArticleRubric_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  primaryCategory?: Maybe<
    | { __typename: "Channel"; displayName: string; url: string }
    | { __typename: "Category"; displayName: string; url: string }
    | { __typename: "EditorialProject"; displayName: string; url: string }
  >;
};

type ArticleRubric_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  primaryCategory?: Maybe<
    | { __typename: "Channel"; displayName: string; url: string }
    | { __typename: "Category"; displayName: string; url: string }
    | { __typename: "EditorialProject"; displayName: string; url: string }
  >;
};

export type ArticleRubricFragment =
  | ArticleRubric_BlogArticle_Fragment
  | ArticleRubric_MagazineArticle_Fragment;

type ArticleShare_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  url: string;
  shareDek?: Maybe<string>;
  shareText?: Maybe<string>;
  shareTitle?: Maybe<string>;
  dek?: Maybe<string>;
  title: string;
};

type ArticleShare_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  url: string;
  shareDek?: Maybe<string>;
  shareText?: Maybe<string>;
  shareTitle?: Maybe<string>;
  dek?: Maybe<string>;
  title: string;
};

export type ArticleShareFragment =
  | ArticleShare_BlogArticle_Fragment
  | ArticleShare_MagazineArticle_Fragment;

type ArticleTimestamp_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  datePublished?: Maybe<string>;
};

type ArticleTimestamp_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  datePublished?: Maybe<string>;
  issue: { __typename: "MagazineIssue"; url: string; issueName: string };
};

export type ArticleTimestampFragment =
  | ArticleTimestamp_BlogArticle_Fragment
  | ArticleTimestamp_MagazineArticle_Fragment;

type ArticleTitle_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  title: string;
};

type ArticleTitle_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  title: string;
};

export type ArticleTitleFragment =
  | ArticleTitle_BlogArticle_Fragment
  | ArticleTitle_MagazineArticle_Fragment;

export type ArticleWellInlineImageFragment = {
  __typename: "ArticleWellInlineImage";
  clickthroughUrl: string;
  crop?: Maybe<{
    __typename: "BasicCrop";
    url: string;
    width: number;
    height: number;
    srcSet: string;
  }>;
} & ArticleInlineImageFigure_ArticleWellInlineImage_Fragment;

export type EditorsNoteSwanFragment = {
  __typename: "EditorsNote";
  content: string;
  datePublished?: Maybe<string>;
};

export type ArticleBentoRecircFragment = {
  __typename: "EditorialProject";
  displayName: string;
  url: string;
  accentColor?: Maybe<string>;
  textColor?: Maybe<string>;
  presentedByUrl?: Maybe<string>;
  presentedByDisplayName?: Maybe<string>;
  titleImage?: Maybe<{ __typename: "BasicCrop"; url: string }>;
  leadImage?: Maybe<{ __typename: "BasicCrop"; url: string }>;
  river: { __typename: "RiverConnection" } & ArticleRecircFragment;
};

export type AuthorBioFragment = {
  __typename: "Author";
  id: string;
  displayName: string;
  url: string;
  headshot?: Maybe<{
    __typename: "BasicImage";
    width: number;
    height: number;
    altText: string;
    srcSet: string;
    url: string;
  }>;
  biography?: Maybe<{ __typename: "Biography"; default?: Maybe<string> }>;
  socialMedia: Array<{
    __typename: "SocialMedia";
    platform: SocialMediaPlatform;
    url: string;
  }>;
};

type ArticleBio_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  authors: Array<{ __typename: "Author" } & AuthorBioFragment>;
};

type ArticleBio_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  authors: Array<{ __typename: "Author" } & AuthorBioFragment>;
};

export type ArticleBioFragment =
  | ArticleBio_BlogArticle_Fragment
  | ArticleBio_MagazineArticle_Fragment;

export type ArticleBylineAuthorFragment = {
  __typename: "Author";
  id: string;
  url: string;
  displayName: string;
};

type ArticleByline_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  authors: Array<{ __typename: "Author" } & ArticleBylineAuthorFragment>;
};

type ArticleByline_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  authors: Array<{ __typename: "Author" } & ArticleBylineAuthorFragment>;
};

export type ArticleBylineFragment =
  | ArticleByline_BlogArticle_Fragment
  | ArticleByline_MagazineArticle_Fragment;

export type ArticleContentFragment = {
  __typename: "ContentSection";
  main: any;
  hasRailAd: boolean;
};

export type ArticleIssueFragment = {
  __typename: "MagazineArticle";
  issue: { __typename: "MagazineIssue"; url: string; issueName: string };
};

type ArticleDateline_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  dateModified?: Maybe<string>;
  datePublished?: Maybe<string>;
  primaryChannel?: Maybe<{ __typename: "Channel"; slug: string }>;
};

type ArticleDateline_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  dateModified?: Maybe<string>;
  datePublished?: Maybe<string>;
  primaryChannel?: Maybe<{ __typename: "Channel"; slug: string }>;
} & ArticleIssueFragment;

export type ArticleDatelineFragment =
  | ArticleDateline_BlogArticle_Fragment
  | ArticleDateline_MagazineArticle_Fragment;

type ArticleDek_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  dek?: Maybe<string>;
  primaryChannel?: Maybe<{ __typename: "Channel"; slug: string }>;
};

type ArticleDek_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  dek?: Maybe<string>;
  primaryChannel?: Maybe<{ __typename: "Channel"; slug: string }>;
};

export type ArticleDekFragment =
  | ArticleDek_BlogArticle_Fragment
  | ArticleDek_MagazineArticle_Fragment;

export type ArticleFoundationLineFragment = {
  __typename: "EditorialProject";
  foundationLineArticle?: Maybe<string>;
};

type ArticleHeader_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  id: string;
  title: string;
  primaryChannel?: Maybe<{ __typename: "Channel"; slug: string }>;
  primaryCategory?: Maybe<
    | { __typename: "Channel"; displayName: string; url: string }
    | { __typename: "Category"; displayName: string; url: string }
    | { __typename: "EditorialProject"; displayName: string; url: string }
  >;
} & ArticleDek_BlogArticle_Fragment &
  ArticleDateline_BlogArticle_Fragment &
  IdeasArticleByline_BlogArticle_Fragment &
  ArticleByline_BlogArticle_Fragment;

type ArticleHeader_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  id: string;
  title: string;
  primaryChannel?: Maybe<{ __typename: "Channel"; slug: string }>;
  primaryCategory?: Maybe<
    | { __typename: "Channel"; displayName: string; url: string }
    | { __typename: "Category"; displayName: string; url: string }
    | { __typename: "EditorialProject"; displayName: string; url: string }
  >;
} & ArticleDek_MagazineArticle_Fragment &
  ArticleDateline_MagazineArticle_Fragment &
  IdeasArticleByline_MagazineArticle_Fragment &
  ArticleByline_MagazineArticle_Fragment;

export type ArticleHeaderFragment =
  | ArticleHeader_BlogArticle_Fragment
  | ArticleHeader_MagazineArticle_Fragment;

export type ArticleJsonLdAuthorFragment = {
  __typename: "Author";
  url: string;
  displayName: string;
};

export type ArticleJsonLdImageFragment = {
  __typename: "BasicImage";
  width: number;
  height: number;
  url: string;
};

type ArticleJsonLdReview_BookReview_Fragment = {
  __typename: "BookReview";
  publisher?: Maybe<string>;
  isbn?: Maybe<string>;
  id: string;
  title: string;
  creator?: Maybe<string>;
  creatorUrl?: Maybe<string>;
  purchaseUrl?: Maybe<string>;
  content?: Maybe<string>;
  url?: Maybe<string>;
  image?: Maybe<{
    __typename: "BasicImage";
    url: string;
    width: number;
    height: number;
    srcSet: string;
    captionText: string;
    attributionText: string;
    attributionUrl: string;
    altText: string;
  }>;
};

type ArticleJsonLdReview_EpisodeReview_Fragment = {
  __typename: "EpisodeReview";
  season: number;
  episode: number;
  id: string;
  title: string;
  creator?: Maybe<string>;
  creatorUrl?: Maybe<string>;
  purchaseUrl?: Maybe<string>;
  content?: Maybe<string>;
  url?: Maybe<string>;
  image?: Maybe<{
    __typename: "BasicImage";
    url: string;
    width: number;
    height: number;
    srcSet: string;
    captionText: string;
    attributionText: string;
    attributionUrl: string;
    altText: string;
  }>;
};

type ArticleJsonLdReview_MovieReview_Fragment = {
  __typename: "MovieReview";
  id: string;
  title: string;
  creator?: Maybe<string>;
  creatorUrl?: Maybe<string>;
  purchaseUrl?: Maybe<string>;
  content?: Maybe<string>;
  url?: Maybe<string>;
  image?: Maybe<{
    __typename: "BasicImage";
    url: string;
    width: number;
    height: number;
    srcSet: string;
    captionText: string;
    attributionText: string;
    attributionUrl: string;
    altText: string;
  }>;
};

type ArticleJsonLdReview_MusicAlbumReview_Fragment = {
  __typename: "MusicAlbumReview";
  id: string;
  title: string;
  creator?: Maybe<string>;
  creatorUrl?: Maybe<string>;
  purchaseUrl?: Maybe<string>;
  content?: Maybe<string>;
  url?: Maybe<string>;
  image?: Maybe<{
    __typename: "BasicImage";
    url: string;
    width: number;
    height: number;
    srcSet: string;
    captionText: string;
    attributionText: string;
    attributionUrl: string;
    altText: string;
  }>;
};

export type ArticleJsonLdReviewFragment =
  | ArticleJsonLdReview_BookReview_Fragment
  | ArticleJsonLdReview_EpisodeReview_Fragment
  | ArticleJsonLdReview_MovieReview_Fragment
  | ArticleJsonLdReview_MusicAlbumReview_Fragment;

type ArticleJsonLdData_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  url: string;
  title: string;
  seoTitle?: Maybe<string>;
  dek?: Maybe<string>;
  dateModified?: Maybe<string>;
  datePublished?: Maybe<string>;
  primaryChannel?: Maybe<{ __typename: "Channel"; displayName: string }>;
  authors: Array<{ __typename: "Author" } & ArticleJsonLdAuthorFragment>;
  reviews: Array<
    | ({ __typename: "BookReview" } & ArticleJsonLdReview_BookReview_Fragment)
    | ({
        __typename: "EpisodeReview";
      } & ArticleJsonLdReview_EpisodeReview_Fragment)
    | ({ __typename: "MovieReview" } & ArticleJsonLdReview_MovieReview_Fragment)
    | ({
        __typename: "MusicAlbumReview";
      } & ArticleJsonLdReview_MusicAlbumReview_Fragment)
  >;
  shareImage1x1?: Maybe<
    { __typename: "BasicImage" } & ArticleJsonLdImageFragment
  >;
  shareImage16x9?: Maybe<
    { __typename: "BasicImage" } & ArticleJsonLdImageFragment
  >;
  shareImage4x3?: Maybe<
    { __typename: "BasicImage" } & ArticleJsonLdImageFragment
  >;
  shareImageDefault?: Maybe<
    { __typename: "BasicImage" } & ArticleJsonLdImageFragment
  >;
  shareImageSquareDefault?: Maybe<
    { __typename: "BasicImage" } & ArticleJsonLdImageFragment
  >;
  shareImageLeadArt?: Maybe<
    | {
        __typename: "LeadArtImage";
        image?: Maybe<
          { __typename: "BasicImage" } & ArticleJsonLdImageFragment
        >;
      }
    | { __typename: "LeadArtImageLarge" }
    | { __typename: "LeadArtEmbed" }
    | { __typename: "Cinemagraph" }
  >;
};

type ArticleJsonLdData_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  url: string;
  title: string;
  seoTitle?: Maybe<string>;
  dek?: Maybe<string>;
  dateModified?: Maybe<string>;
  datePublished?: Maybe<string>;
  primaryChannel?: Maybe<{ __typename: "Channel"; displayName: string }>;
  authors: Array<{ __typename: "Author" } & ArticleJsonLdAuthorFragment>;
  reviews: Array<
    | ({ __typename: "BookReview" } & ArticleJsonLdReview_BookReview_Fragment)
    | ({
        __typename: "EpisodeReview";
      } & ArticleJsonLdReview_EpisodeReview_Fragment)
    | ({ __typename: "MovieReview" } & ArticleJsonLdReview_MovieReview_Fragment)
    | ({
        __typename: "MusicAlbumReview";
      } & ArticleJsonLdReview_MusicAlbumReview_Fragment)
  >;
  shareImage1x1?: Maybe<
    { __typename: "BasicImage" } & ArticleJsonLdImageFragment
  >;
  shareImage16x9?: Maybe<
    { __typename: "BasicImage" } & ArticleJsonLdImageFragment
  >;
  shareImage4x3?: Maybe<
    { __typename: "BasicImage" } & ArticleJsonLdImageFragment
  >;
  shareImageDefault?: Maybe<
    { __typename: "BasicImage" } & ArticleJsonLdImageFragment
  >;
  shareImageSquareDefault?: Maybe<
    { __typename: "BasicImage" } & ArticleJsonLdImageFragment
  >;
  shareImageLeadArt?: Maybe<
    | {
        __typename: "LeadArtImage";
        image?: Maybe<
          { __typename: "BasicImage" } & ArticleJsonLdImageFragment
        >;
      }
    | { __typename: "LeadArtImageLarge" }
    | { __typename: "LeadArtEmbed" }
    | { __typename: "Cinemagraph" }
  >;
};

export type ArticleJsonLdDataFragment =
  | ArticleJsonLdData_BlogArticle_Fragment
  | ArticleJsonLdData_MagazineArticle_Fragment;

type ArticleLeadArt_LeadArtImage_Fragment = {
  __typename: "LeadArtImage";
  image?: Maybe<{
    __typename: "BasicImage";
    url: string;
    width: number;
    height: number;
    srcSet: string;
    captionText: string;
    attributionText: string;
    attributionUrl: string;
    altText: string;
  }>;
};

type ArticleLeadArt_LeadArtImageLarge_Fragment = {
  __typename: "LeadArtImageLarge";
};

type ArticleLeadArt_LeadArtEmbed_Fragment = {
  __typename: "LeadArtEmbed";
  src: string;
  width: string;
  height: string;
  caption: string;
};

type ArticleLeadArt_Cinemagraph_Fragment = {
  __typename: "Cinemagraph";
  attributionText?: Maybe<string>;
  captionText?: Maybe<string>;
  formats: Array<{
    __typename: "VideoFormat";
    encoding?: Maybe<VideoEncoding>;
    url?: Maybe<string>;
  }>;
  poster?: Maybe<{ __typename: "BasicCrop"; url: string }>;
};

export type ArticleLeadArtFragment =
  | ArticleLeadArt_LeadArtImage_Fragment
  | ArticleLeadArt_LeadArtImageLarge_Fragment
  | ArticleLeadArt_LeadArtEmbed_Fragment
  | ArticleLeadArt_Cinemagraph_Fragment;

type ArticleMetadata_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  title: string;
  seoTitle?: Maybe<string>;
  shareTitle?: Maybe<string>;
  dek?: Maybe<string>;
  shareDek?: Maybe<string>;
  url: string;
  ampUrl?: Maybe<string>;
  fbiaUrl?: Maybe<string>;
  canonicalUrl: string;
  hasMeter?: Maybe<boolean>;
  datePublished?: Maybe<string>;
  dateModified?: Maybe<string>;
  shareImage2x1?: Maybe<{
    __typename: "BasicImage";
    url: string;
    height: number;
    width: number;
  }>;
  primaryChannel?: Maybe<{ __typename: "Channel"; displayName: string }>;
  authors: Array<{
    __typename: "Author";
    displayName: string;
    socialMedia: Array<{
      __typename: "SocialMedia";
      platform: SocialMediaPlatform;
      url: string;
    }>;
  }>;
  channels: Array<{ __typename: "Channel"; slug: string }>;
  watsonInfo?: Maybe<{ __typename: "WatsonInfo"; keywords: Array<string> }>;
};

type ArticleMetadata_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  title: string;
  seoTitle?: Maybe<string>;
  shareTitle?: Maybe<string>;
  dek?: Maybe<string>;
  shareDek?: Maybe<string>;
  url: string;
  ampUrl?: Maybe<string>;
  fbiaUrl?: Maybe<string>;
  canonicalUrl: string;
  hasMeter?: Maybe<boolean>;
  datePublished?: Maybe<string>;
  dateModified?: Maybe<string>;
  shareImage2x1?: Maybe<{
    __typename: "BasicImage";
    url: string;
    height: number;
    width: number;
  }>;
  primaryChannel?: Maybe<{ __typename: "Channel"; displayName: string }>;
  authors: Array<{
    __typename: "Author";
    displayName: string;
    socialMedia: Array<{
      __typename: "SocialMedia";
      platform: SocialMediaPlatform;
      url: string;
    }>;
  }>;
  channels: Array<{ __typename: "Channel"; slug: string }>;
  watsonInfo?: Maybe<{ __typename: "WatsonInfo"; keywords: Array<string> }>;
};

export type ArticleMetadataFragment =
  | ArticleMetadata_BlogArticle_Fragment
  | ArticleMetadata_MagazineArticle_Fragment;

export type ArticleMostPopularAuthorFragment = {
  __typename: "Author";
  id: string;
  displayName: string;
  slug: string;
  url: string;
};

type ArticleMostPopularPromoItem_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & ArticleMostPopularAuthorFragment>;
  riverImage1x1?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
  riverImage3x2?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleMostPopularPromoItem_CuratedArticle_Fragment = {
  __typename: "CuratedArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & ArticleMostPopularAuthorFragment>;
  riverImage1x1?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
  riverImage3x2?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleMostPopularPromoItem_HomepagePromoItem_Fragment = {
  __typename: "HomepagePromoItem";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & ArticleMostPopularAuthorFragment>;
  riverImage1x1?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
  riverImage3x2?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleMostPopularPromoItem_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & ArticleMostPopularAuthorFragment>;
  riverImage1x1?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
  riverImage3x2?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleMostPopularPromoItem_MagazineIssue_Fragment = {
  __typename: "MagazineIssue";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & ArticleMostPopularAuthorFragment>;
  riverImage1x1?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
  riverImage3x2?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleMostPopularPromoItem_NotesArticle_Fragment = {
  __typename: "NotesArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & ArticleMostPopularAuthorFragment>;
  riverImage1x1?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
  riverImage3x2?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleMostPopularPromoItem_PhotoArticle_Fragment = {
  __typename: "PhotoArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & ArticleMostPopularAuthorFragment>;
  riverImage1x1?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
  riverImage3x2?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleMostPopularPromoItem_PodcastEpisode_Fragment = {
  __typename: "PodcastEpisode";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & ArticleMostPopularAuthorFragment>;
  riverImage1x1?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
  riverImage3x2?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

type ArticleMostPopularPromoItem_VideoArticle_Fragment = {
  __typename: "VideoArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & ArticleMostPopularAuthorFragment>;
  riverImage1x1?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
  riverImage3x2?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
};

export type ArticleMostPopularPromoItemFragment =
  | ArticleMostPopularPromoItem_BlogArticle_Fragment
  | ArticleMostPopularPromoItem_CuratedArticle_Fragment
  | ArticleMostPopularPromoItem_HomepagePromoItem_Fragment
  | ArticleMostPopularPromoItem_MagazineArticle_Fragment
  | ArticleMostPopularPromoItem_MagazineIssue_Fragment
  | ArticleMostPopularPromoItem_NotesArticle_Fragment
  | ArticleMostPopularPromoItem_PhotoArticle_Fragment
  | ArticleMostPopularPromoItem_PodcastEpisode_Fragment
  | ArticleMostPopularPromoItem_VideoArticle_Fragment;

export type ArticleMostPopularFragment = {
  __typename: "CuratedGroup";
  displayName: string;
  river: {
    __typename: "RiverConnection";
    edges: Array<{
      __typename: "PromoEdge";
      cursor: string;
      node:
        | ({
            __typename: "BlogArticle";
          } & ArticleMostPopularPromoItem_BlogArticle_Fragment)
        | ({
            __typename: "CuratedArticle";
          } & ArticleMostPopularPromoItem_CuratedArticle_Fragment)
        | ({
            __typename: "HomepagePromoItem";
          } & ArticleMostPopularPromoItem_HomepagePromoItem_Fragment)
        | ({
            __typename: "MagazineArticle";
          } & ArticleMostPopularPromoItem_MagazineArticle_Fragment)
        | ({
            __typename: "MagazineIssue";
          } & ArticleMostPopularPromoItem_MagazineIssue_Fragment)
        | ({
            __typename: "NotesArticle";
          } & ArticleMostPopularPromoItem_NotesArticle_Fragment)
        | ({
            __typename: "PhotoArticle";
          } & ArticleMostPopularPromoItem_PhotoArticle_Fragment)
        | ({
            __typename: "PodcastEpisode";
          } & ArticleMostPopularPromoItem_PodcastEpisode_Fragment)
        | ({
            __typename: "VideoArticle";
          } & ArticleMostPopularPromoItem_VideoArticle_Fragment);
    }>;
  };
};

export type ArticleMostPopularQueryVariables = Exact<{ [key: string]: never }>;

export type ArticleMostPopularQuery = {
  __typename: "Query";
  mostPopular: { __typename: "CuratedGroup" } & ArticleMostPopularFragment;
};

export type RelatedContentQueryVariables = Exact<{
  id: Scalars["ID"];
  preview?: Maybe<Scalars["String"]>;
}>;

export type RelatedContentQuery = {
  __typename: "Query";
  relatedContent?: Maybe<{
    __typename: "RelatedContent";
    displayName: string;
    river: { __typename: "RiverConnection" } & ArticleRecircFragment;
  }>;
};

export type EditorsNoteFragment = {
  __typename: "EditorsNote";
  content: string;
};

export type GooseArticleQueryVariables = Exact<{
  id: Scalars["ID"];
  preview?: Maybe<Scalars["String"]>;
}>;

export type GooseArticleQuery = {
  __typename: "Query";
  article:
    | ({
        __typename: "BlogArticle";
        id: string;
        isTnfCompatible: boolean;
        datePublished?: Maybe<string>;
        title: string;
        slug: string;
        wordCount: number;
        layout: ArticleLayout;
        isFreelance?: Maybe<boolean>;
        isPython3?: Maybe<boolean>;
        preview?: Maybe<string>;
        watsonInfo?: Maybe<{
          __typename: "WatsonInfo";
          categories: Array<string>;
          topCategory: {
            __typename: "WatsonTopCategory";
            full: string;
            one?: Maybe<string>;
            two?: Maybe<string>;
            three?: Maybe<string>;
            four?: Maybe<string>;
          };
        }>;
        grapeshot?: Maybe<{ __typename: "Grapeshot"; segments: Array<string> }>;
        editorialMotivation?: Maybe<{
          __typename: "EditorialMotivation";
          slug: string;
        }>;
        editorialProject?: Maybe<
          {
            __typename: "EditorialProject";
            slug: string;
            displayName: string;
          } & ArticleBentoRecircFragment &
            ArticleFoundationLineFragment
        >;
        htmlContentSections: Array<
          { __typename: "ContentSection" } & ArticleContentFragment
        >;
        leadArt?: Maybe<
          | ({
              __typename: "LeadArtImage";
            } & ArticleLeadArt_LeadArtImage_Fragment)
          | ({
              __typename: "LeadArtImageLarge";
            } & ArticleLeadArt_LeadArtImageLarge_Fragment)
          | ({
              __typename: "LeadArtEmbed";
            } & ArticleLeadArt_LeadArtEmbed_Fragment)
          | ({
              __typename: "Cinemagraph";
            } & ArticleLeadArt_Cinemagraph_Fragment)
        >;
        embeds: Array<{ __typename: "Embed"; type: string; src: string }>;
        primaryChannel?: Maybe<{
          __typename: "Channel";
          slug: string;
          displayName: string;
        }>;
        categories: Array<{ __typename: "Category"; slug: string }>;
        channels: Array<{ __typename: "Channel"; slug: string }>;
        editorsNote?: Maybe<
          { __typename: "EditorsNote" } & EditorsNoteFragment
        >;
        advertisingInfo?: Maybe<{
          __typename: "AdvertisingInfo";
          disableHouseAd: boolean;
        }>;
      } & ArticleMetadata_BlogArticle_Fragment &
        ArticleHeader_BlogArticle_Fragment &
        ArticleBio_BlogArticle_Fragment &
        ArticleJsonLdData_BlogArticle_Fragment)
    | ({
        __typename: "MagazineArticle";
        id: string;
        isTnfCompatible: boolean;
        datePublished?: Maybe<string>;
        title: string;
        slug: string;
        wordCount: number;
        layout: ArticleLayout;
        isFreelance?: Maybe<boolean>;
        isPython3?: Maybe<boolean>;
        preview?: Maybe<string>;
        issue: { __typename: "MagazineIssue"; issueName: string; slug: string };
        watsonInfo?: Maybe<{
          __typename: "WatsonInfo";
          categories: Array<string>;
          topCategory: {
            __typename: "WatsonTopCategory";
            full: string;
            one?: Maybe<string>;
            two?: Maybe<string>;
            three?: Maybe<string>;
            four?: Maybe<string>;
          };
        }>;
        grapeshot?: Maybe<{ __typename: "Grapeshot"; segments: Array<string> }>;
        editorialMotivation?: Maybe<{
          __typename: "EditorialMotivation";
          slug: string;
        }>;
        editorialProject?: Maybe<
          {
            __typename: "EditorialProject";
            slug: string;
            displayName: string;
          } & ArticleBentoRecircFragment &
            ArticleFoundationLineFragment
        >;
        htmlContentSections: Array<
          { __typename: "ContentSection" } & ArticleContentFragment
        >;
        leadArt?: Maybe<
          | ({
              __typename: "LeadArtImage";
            } & ArticleLeadArt_LeadArtImage_Fragment)
          | ({
              __typename: "LeadArtImageLarge";
            } & ArticleLeadArt_LeadArtImageLarge_Fragment)
          | ({
              __typename: "LeadArtEmbed";
            } & ArticleLeadArt_LeadArtEmbed_Fragment)
          | ({
              __typename: "Cinemagraph";
            } & ArticleLeadArt_Cinemagraph_Fragment)
        >;
        embeds: Array<{ __typename: "Embed"; type: string; src: string }>;
        primaryChannel?: Maybe<{
          __typename: "Channel";
          slug: string;
          displayName: string;
        }>;
        categories: Array<{ __typename: "Category"; slug: string }>;
        channels: Array<{ __typename: "Channel"; slug: string }>;
        editorsNote?: Maybe<
          { __typename: "EditorsNote" } & EditorsNoteFragment
        >;
        advertisingInfo?: Maybe<{
          __typename: "AdvertisingInfo";
          disableHouseAd: boolean;
        }>;
      } & ArticleMetadata_MagazineArticle_Fragment &
        ArticleHeader_MagazineArticle_Fragment &
        ArticleBio_MagazineArticle_Fragment &
        ArticleJsonLdData_MagazineArticle_Fragment);
};

type IdeasArticleByline_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  authors: Array<{
    __typename: "Author";
    id: string;
    url: string;
    displayName: string;
    ideasHeadshot?: Maybe<{
      __typename: "BasicImage";
      width: number;
      height: number;
      altText: string;
      srcSet: string;
      url: string;
    }>;
    biography?: Maybe<{ __typename: "Biography"; short?: Maybe<string> }>;
  }>;
};

type IdeasArticleByline_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  authors: Array<{
    __typename: "Author";
    id: string;
    url: string;
    displayName: string;
    ideasHeadshot?: Maybe<{
      __typename: "BasicImage";
      width: number;
      height: number;
      altText: string;
      srcSet: string;
      url: string;
    }>;
    biography?: Maybe<{ __typename: "Biography"; short?: Maybe<string> }>;
  }>;
};

export type IdeasArticleBylineFragment =
  | IdeasArticleByline_BlogArticle_Fragment
  | IdeasArticleByline_MagazineArticle_Fragment;

export type DoubleWideQueryVariables = Exact<{ [key: string]: never }>;

export type DoubleWideQuery = {
  __typename: "Query";
  homepageModule?: Maybe<
    | {
        __typename: "HomepagePromoItem";
        title: string;
        dek?: Maybe<string>;
        url: string;
        kicker?: Maybe<string>;
        kickerUrl?: Maybe<string>;
        authors: Array<{
          __typename: "Author";
          id: string;
          displayName: string;
          url: string;
        }>;
        mobileImage?: Maybe<{
          __typename: "BasicImage";
          url: string;
          width: number;
          height: number;
          srcSet: string;
          altText: string;
          attributionText: string;
          attributionUrl: string;
        }>;
        desktopImage?: Maybe<{ __typename: "BasicImage"; srcSet: string }>;
      }
    | { __typename: "HomepagePromoItemList" }
  >;
};

export type HomepageChannelFragment = {
  __typename: "Channel";
  id: string;
  url: string;
  displayName: string;
  slug: string;
  river: {
    __typename: "RiverConnection";
    edges: Array<{
      __typename: "PromoEdge";
      node:
        | { __typename: "BlogArticle"; id: string; title: string; url: string }
        | {
            __typename: "CuratedArticle";
            id: string;
            title: string;
            url: string;
          }
        | {
            __typename: "HomepagePromoItem";
            id: string;
            title: string;
            url: string;
          }
        | {
            __typename: "MagazineArticle";
            id: string;
            title: string;
            url: string;
          }
        | {
            __typename: "MagazineIssue";
            id: string;
            title: string;
            url: string;
          }
        | { __typename: "NotesArticle"; id: string; title: string; url: string }
        | { __typename: "PhotoArticle"; id: string; title: string; url: string }
        | {
            __typename: "PodcastEpisode";
            id: string;
            title: string;
            url: string;
          }
        | {
            __typename: "VideoArticle";
            id: string;
            title: string;
            url: string;
          };
    }>;
  };
};

export type HomepageChannelsQueryVariables = Exact<{ [key: string]: never }>;

export type HomepageChannelsQuery = {
  __typename: "Query";
  politics: { __typename: "Channel" } & HomepageChannelFragment;
  culture: { __typename: "Channel" } & HomepageChannelFragment;
  technology: { __typename: "Channel" } & HomepageChannelFragment;
  ideas: { __typename: "Channel" } & HomepageChannelFragment;
  science: { __typename: "Channel" } & HomepageChannelFragment;
  books: { __typename: "Channel" } & HomepageChannelFragment;
  family: { __typename: "Channel" } & HomepageChannelFragment;
  business: { __typename: "Channel" } & HomepageChannelFragment;
  global: { __typename: "Channel" } & HomepageChannelFragment;
  health: { __typename: "Channel" } & HomepageChannelFragment;
  education: { __typename: "Channel" } & HomepageChannelFragment;
  letters: { __typename: "Channel" } & HomepageChannelFragment;
};

export type HomepageAuthorFragment = {
  __typename: "Author";
  id: string;
  url: string;
  displayName: string;
};

type HomepageMetadata_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & HomepageAuthorFragment>;
};

type HomepageMetadata_CuratedArticle_Fragment = {
  __typename: "CuratedArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & HomepageAuthorFragment>;
};

type HomepageMetadata_HomepagePromoItem_Fragment = {
  __typename: "HomepagePromoItem";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & HomepageAuthorFragment>;
};

type HomepageMetadata_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & HomepageAuthorFragment>;
};

type HomepageMetadata_MagazineIssue_Fragment = {
  __typename: "MagazineIssue";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & HomepageAuthorFragment>;
};

type HomepageMetadata_NotesArticle_Fragment = {
  __typename: "NotesArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & HomepageAuthorFragment>;
};

type HomepageMetadata_PhotoArticle_Fragment = {
  __typename: "PhotoArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & HomepageAuthorFragment>;
};

type HomepageMetadata_PodcastEpisode_Fragment = {
  __typename: "PodcastEpisode";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & HomepageAuthorFragment>;
};

type HomepageMetadata_VideoArticle_Fragment = {
  __typename: "VideoArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & HomepageAuthorFragment>;
};

export type HomepageMetadataFragment =
  | HomepageMetadata_BlogArticle_Fragment
  | HomepageMetadata_CuratedArticle_Fragment
  | HomepageMetadata_HomepagePromoItem_Fragment
  | HomepageMetadata_MagazineArticle_Fragment
  | HomepageMetadata_MagazineIssue_Fragment
  | HomepageMetadata_NotesArticle_Fragment
  | HomepageMetadata_PhotoArticle_Fragment
  | HomepageMetadata_PodcastEpisode_Fragment
  | HomepageMetadata_VideoArticle_Fragment;

export type LatestAuthorFragment = {
  __typename: "Author";
  id: string;
  displayName: string;
  url: string;
  slug: string;
};

type LatestArticle_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  id: string;
  title: string;
  url: string;
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LatestAuthorFragment>;
  squareImage?: Maybe<{
    __typename: "BasicImage";
    altText: string;
    srcSet: string;
    url: string;
    width: number;
    height: number;
  }>;
  wideImage?: Maybe<{ __typename: "BasicImage"; srcSet: string }>;
};

type LatestArticle_CuratedArticle_Fragment = {
  __typename: "CuratedArticle";
  id: string;
  title: string;
  url: string;
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LatestAuthorFragment>;
  squareImage?: Maybe<{
    __typename: "BasicImage";
    altText: string;
    srcSet: string;
    url: string;
    width: number;
    height: number;
  }>;
  wideImage?: Maybe<{ __typename: "BasicImage"; srcSet: string }>;
};

type LatestArticle_HomepagePromoItem_Fragment = {
  __typename: "HomepagePromoItem";
  id: string;
  title: string;
  url: string;
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LatestAuthorFragment>;
  squareImage?: Maybe<{
    __typename: "BasicImage";
    altText: string;
    srcSet: string;
    url: string;
    width: number;
    height: number;
  }>;
  wideImage?: Maybe<{ __typename: "BasicImage"; srcSet: string }>;
};

type LatestArticle_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  id: string;
  title: string;
  url: string;
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LatestAuthorFragment>;
  squareImage?: Maybe<{
    __typename: "BasicImage";
    altText: string;
    srcSet: string;
    url: string;
    width: number;
    height: number;
  }>;
  wideImage?: Maybe<{ __typename: "BasicImage"; srcSet: string }>;
};

type LatestArticle_MagazineIssue_Fragment = {
  __typename: "MagazineIssue";
  id: string;
  title: string;
  url: string;
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LatestAuthorFragment>;
  squareImage?: Maybe<{
    __typename: "BasicImage";
    altText: string;
    srcSet: string;
    url: string;
    width: number;
    height: number;
  }>;
  wideImage?: Maybe<{ __typename: "BasicImage"; srcSet: string }>;
};

type LatestArticle_NotesArticle_Fragment = {
  __typename: "NotesArticle";
  id: string;
  title: string;
  url: string;
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LatestAuthorFragment>;
  squareImage?: Maybe<{
    __typename: "BasicImage";
    altText: string;
    srcSet: string;
    url: string;
    width: number;
    height: number;
  }>;
  wideImage?: Maybe<{ __typename: "BasicImage"; srcSet: string }>;
};

type LatestArticle_PhotoArticle_Fragment = {
  __typename: "PhotoArticle";
  id: string;
  title: string;
  url: string;
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LatestAuthorFragment>;
  squareImage?: Maybe<{
    __typename: "BasicImage";
    altText: string;
    srcSet: string;
    url: string;
    width: number;
    height: number;
  }>;
  wideImage?: Maybe<{ __typename: "BasicImage"; srcSet: string }>;
};

type LatestArticle_PodcastEpisode_Fragment = {
  __typename: "PodcastEpisode";
  id: string;
  title: string;
  url: string;
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LatestAuthorFragment>;
  squareImage?: Maybe<{
    __typename: "BasicImage";
    altText: string;
    srcSet: string;
    url: string;
    width: number;
    height: number;
  }>;
  wideImage?: Maybe<{ __typename: "BasicImage"; srcSet: string }>;
};

type LatestArticle_VideoArticle_Fragment = {
  __typename: "VideoArticle";
  id: string;
  title: string;
  url: string;
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LatestAuthorFragment>;
  squareImage?: Maybe<{
    __typename: "BasicImage";
    altText: string;
    srcSet: string;
    url: string;
    width: number;
    height: number;
  }>;
  wideImage?: Maybe<{ __typename: "BasicImage"; srcSet: string }>;
};

export type LatestArticleFragment =
  | LatestArticle_BlogArticle_Fragment
  | LatestArticle_CuratedArticle_Fragment
  | LatestArticle_HomepagePromoItem_Fragment
  | LatestArticle_MagazineArticle_Fragment
  | LatestArticle_MagazineIssue_Fragment
  | LatestArticle_NotesArticle_Fragment
  | LatestArticle_PhotoArticle_Fragment
  | LatestArticle_PodcastEpisode_Fragment
  | LatestArticle_VideoArticle_Fragment;

export type HomepageLatestQueryVariables = Exact<{ [key: string]: never }>;

export type HomepageLatestQuery = {
  __typename: "Query";
  latest: {
    __typename: "Latest";
    id: string;
    slug: string;
    displayName: string;
    url: string;
    river: {
      __typename: "RiverConnection";
      edges: Array<{
        __typename: "PromoEdge";
        node:
          | ({ __typename: "BlogArticle" } & LatestArticle_BlogArticle_Fragment)
          | ({
              __typename: "CuratedArticle";
            } & LatestArticle_CuratedArticle_Fragment)
          | ({
              __typename: "HomepagePromoItem";
            } & LatestArticle_HomepagePromoItem_Fragment)
          | ({
              __typename: "MagazineArticle";
            } & LatestArticle_MagazineArticle_Fragment)
          | ({
              __typename: "MagazineIssue";
            } & LatestArticle_MagazineIssue_Fragment)
          | ({
              __typename: "NotesArticle";
            } & LatestArticle_NotesArticle_Fragment)
          | ({
              __typename: "PhotoArticle";
            } & LatestArticle_PhotoArticle_Fragment)
          | ({
              __typename: "PodcastEpisode";
            } & LatestArticle_PodcastEpisode_Fragment)
          | ({
              __typename: "VideoArticle";
            } & LatestArticle_VideoArticle_Fragment);
      }>;
    };
  };
};

export type HomepageLedeQueryVariables = Exact<{ [key: string]: never }>;

export type HomepageLedeQuery = {
  __typename: "Query";
  homepageModule?: Maybe<
    | {
        __typename: "HomepagePromoItem";
        id: string;
        url: string;
        title: string;
        dek?: Maybe<string>;
        kicker?: Maybe<string>;
        kickerUrl?: Maybe<string>;
        authors: Array<{
          __typename: "Author";
          id: string;
          url: string;
          displayName: string;
        }>;
        riverImage?: Maybe<{
          __typename: "BasicImage";
          url: string;
          srcSet: string;
          width: number;
          height: number;
          altText: string;
          attributionText: string;
          attributionUrl: string;
        }>;
      }
    | { __typename: "HomepagePromoItemList" }
  >;
};

export type HomepageOffledeQueryVariables = Exact<{ [key: string]: never }>;

export type HomepageOffledeQuery = {
  __typename: "Query";
  homepageModule?: Maybe<
    | { __typename: "HomepagePromoItem" }
    | {
        __typename: "HomepagePromoItemList";
        items: Array<{
          __typename: "HomepagePromoItem";
          id: string;
          url: string;
          title: string;
          wideImage?: Maybe<{
            __typename: "BasicImage";
            url: string;
            width: number;
            height: number;
            srcSet: string;
            altText: string;
            attributionText: string;
            attributionUrl: string;
          }>;
          authors: Array<{
            __typename: "Author";
            id: string;
            url: string;
            displayName: string;
          }>;
        }>;
      }
  >;
};

export type PodcastEpisodeFragment = {
  __typename: "PodcastEpisode";
  id: string;
  url: string;
  title: string;
  kicker?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    url: string;
    srcSet: string;
    altText: string;
  }>;
};

export type HomepagePodcastsQueryVariables = Exact<{ [key: string]: never }>;

export type HomepagePodcastsQuery = {
  __typename: "Query";
  activePodcastSeries: Array<{
    __typename: "PodcastSeries";
    id: string;
    displayName: string;
    url?: Maybe<string>;
    river: {
      __typename: "RiverConnection";
      edges: Array<{
        __typename: "PromoEdge";
        node:
          | { __typename: "BlogArticle" }
          | { __typename: "CuratedArticle" }
          | { __typename: "HomepagePromoItem" }
          | { __typename: "MagazineArticle" }
          | { __typename: "MagazineIssue" }
          | { __typename: "NotesArticle" }
          | { __typename: "PhotoArticle" }
          | ({ __typename: "PodcastEpisode" } & PodcastEpisodeFragment)
          | { __typename: "VideoArticle" };
      }>;
    };
  }>;
};

export type HomepageMostPopularQueryVariables = Exact<{ [key: string]: never }>;

export type HomepageMostPopularQuery = {
  __typename: "Query";
  mostPopular: {
    __typename: "CuratedGroup";
    river: {
      __typename: "RiverConnection";
      edges: Array<{
        __typename: "PromoEdge";
        node:
          | {
              __typename: "BlogArticle";
              id: string;
              url: string;
              title: string;
              authors: Array<{
                __typename: "Author";
                id: string;
                displayName: string;
                url: string;
              }>;
              riverImage?: Maybe<{
                __typename: "BasicImage";
                url: string;
                srcSet: string;
                altText: string;
                width: number;
                height: number;
              }>;
            }
          | {
              __typename: "CuratedArticle";
              id: string;
              url: string;
              title: string;
              authors: Array<{
                __typename: "Author";
                id: string;
                displayName: string;
                url: string;
              }>;
              riverImage?: Maybe<{
                __typename: "BasicImage";
                url: string;
                srcSet: string;
                altText: string;
                width: number;
                height: number;
              }>;
            }
          | {
              __typename: "HomepagePromoItem";
              id: string;
              url: string;
              title: string;
              authors: Array<{
                __typename: "Author";
                id: string;
                displayName: string;
                url: string;
              }>;
              riverImage?: Maybe<{
                __typename: "BasicImage";
                url: string;
                srcSet: string;
                altText: string;
                width: number;
                height: number;
              }>;
            }
          | {
              __typename: "MagazineArticle";
              id: string;
              url: string;
              title: string;
              authors: Array<{
                __typename: "Author";
                id: string;
                displayName: string;
                url: string;
              }>;
              riverImage?: Maybe<{
                __typename: "BasicImage";
                url: string;
                srcSet: string;
                altText: string;
                width: number;
                height: number;
              }>;
            }
          | {
              __typename: "MagazineIssue";
              id: string;
              url: string;
              title: string;
              authors: Array<{
                __typename: "Author";
                id: string;
                displayName: string;
                url: string;
              }>;
              riverImage?: Maybe<{
                __typename: "BasicImage";
                url: string;
                srcSet: string;
                altText: string;
                width: number;
                height: number;
              }>;
            }
          | {
              __typename: "NotesArticle";
              id: string;
              url: string;
              title: string;
              authors: Array<{
                __typename: "Author";
                id: string;
                displayName: string;
                url: string;
              }>;
              riverImage?: Maybe<{
                __typename: "BasicImage";
                url: string;
                srcSet: string;
                altText: string;
                width: number;
                height: number;
              }>;
            }
          | {
              __typename: "PhotoArticle";
              id: string;
              url: string;
              title: string;
              authors: Array<{
                __typename: "Author";
                id: string;
                displayName: string;
                url: string;
              }>;
              riverImage?: Maybe<{
                __typename: "BasicImage";
                url: string;
                srcSet: string;
                altText: string;
                width: number;
                height: number;
              }>;
            }
          | {
              __typename: "PodcastEpisode";
              id: string;
              url: string;
              title: string;
              authors: Array<{
                __typename: "Author";
                id: string;
                displayName: string;
                url: string;
              }>;
              riverImage?: Maybe<{
                __typename: "BasicImage";
                url: string;
                srcSet: string;
                altText: string;
                width: number;
                height: number;
              }>;
            }
          | {
              __typename: "VideoArticle";
              id: string;
              url: string;
              title: string;
              authors: Array<{
                __typename: "Author";
                id: string;
                displayName: string;
                url: string;
              }>;
              riverImage?: Maybe<{
                __typename: "BasicImage";
                url: string;
                srcSet: string;
                altText: string;
                width: number;
                height: number;
              }>;
            };
      }>;
    };
  };
};

export type HomepageSmallPromoItemFragment = {
  __typename: "HomepagePromoItem";
  id: string;
  title: string;
  dek?: Maybe<string>;
  url: string;
  authors: Array<{
    __typename: "Author";
    id: string;
    displayName: string;
    url: string;
  }>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    url: string;
    width: number;
    height: number;
    srcSet: string;
    altText: string;
  }>;
};

export type StoryStripQueryVariables = Exact<{ [key: string]: never }>;

export type StoryStripQuery = {
  __typename: "Query";
  homepageModule?: Maybe<
    | { __typename: "HomepagePromoItem" }
    | {
        __typename: "HomepagePromoItemList";
        items: Array<
          { __typename: "HomepagePromoItem" } & HomepageSmallPromoItemFragment
        >;
      }
  >;
};

export type TopStackQueryVariables = Exact<{ [key: string]: never }>;

export type TopStackQuery = {
  __typename: "Query";
  homepageModule?: Maybe<
    | { __typename: "HomepagePromoItem" }
    | {
        __typename: "HomepagePromoItemList";
        items: Array<
          { __typename: "HomepagePromoItem" } & HomepageSmallPromoItemFragment
        >;
      }
  >;
};

export type HomepageUpperBeltAuthorFragment = {
  __typename: "Author";
  id: string;
  url: string;
  displayName: string;
};

export type HomepageUpperBeltQueryVariables = Exact<{ [key: string]: never }>;

export type HomepageUpperBeltQuery = {
  __typename: "Query";
  homepageModule?: Maybe<
    | { __typename: "HomepagePromoItem" }
    | {
        __typename: "HomepagePromoItemList";
        items: Array<{
          __typename: "HomepagePromoItem";
          id: string;
          url: string;
          title: string;
          dek?: Maybe<string>;
          kicker?: Maybe<string>;
          kickerUrl?: Maybe<string>;
          squareImage?: Maybe<{
            __typename: "BasicImage";
            url: string;
            width: number;
            height: number;
            srcSet: string;
            altText: string;
            attributionText: string;
            attributionUrl: string;
          }>;
          wideImage?: Maybe<{ __typename: "BasicImage"; srcSet: string }>;
          authors: Array<
            { __typename: "Author" } & HomepageUpperBeltAuthorFragment
          >;
        }>;
      }
  >;
};

export type HomepageWritersQueryVariables = Exact<{ [key: string]: never }>;

export type HomepageWritersQuery = {
  __typename: "Query";
  curatedAuthorGroup: {
    __typename: "CuratedAuthorGroup";
    id: string;
    displayName: string;
    river: {
      __typename: "AuthorRiverConnection";
      edges: Array<{
        __typename: "AuthorEdge";
        id: string;
        node: {
          __typename: "Author";
          displayName: string;
          url: string;
          headshot?: Maybe<{
            __typename: "BasicImage";
            url: string;
            srcSet: string;
            altText: string;
            width: number;
            height: number;
          }>;
          river: {
            __typename: "RiverConnection";
            edges: Array<{
              __typename: "PromoEdge";
              node:
                | { __typename: "BlogArticle"; title: string; url: string }
                | { __typename: "CuratedArticle"; title: string; url: string }
                | {
                    __typename: "HomepagePromoItem";
                    title: string;
                    url: string;
                  }
                | { __typename: "MagazineArticle"; title: string; url: string }
                | { __typename: "MagazineIssue"; title: string; url: string }
                | { __typename: "NotesArticle"; title: string; url: string }
                | { __typename: "PhotoArticle"; title: string; url: string }
                | { __typename: "PodcastEpisode"; title: string; url: string }
                | { __typename: "VideoArticle"; title: string; url: string };
            }>;
          };
        };
      }>;
    };
  };
};

export type ChannelEditorialProjectFragment = {
  __typename: "EditorialProject";
  url: string;
  displayName: string;
  river: {
    __typename: "RiverConnection";
    edges: Array<{
      __typename: "PromoEdge";
      node:
        | ({
            __typename: "BlogArticle";
            id: string;
            url: string;
            title: string;
            dek?: Maybe<string>;
            riverImage?: Maybe<{
              __typename: "BasicImage";
              id: string;
              url: string;
              srcSet: string;
              width: number;
              height: number;
              altText: string;
            }>;
          } & LandingMetadata_BlogArticle_Fragment)
        | ({
            __typename: "CuratedArticle";
            id: string;
            url: string;
            title: string;
            dek?: Maybe<string>;
            riverImage?: Maybe<{
              __typename: "BasicImage";
              id: string;
              url: string;
              srcSet: string;
              width: number;
              height: number;
              altText: string;
            }>;
          } & LandingMetadata_CuratedArticle_Fragment)
        | ({
            __typename: "HomepagePromoItem";
            id: string;
            url: string;
            title: string;
            dek?: Maybe<string>;
            riverImage?: Maybe<{
              __typename: "BasicImage";
              id: string;
              url: string;
              srcSet: string;
              width: number;
              height: number;
              altText: string;
            }>;
          } & LandingMetadata_HomepagePromoItem_Fragment)
        | ({
            __typename: "MagazineArticle";
            id: string;
            url: string;
            title: string;
            dek?: Maybe<string>;
            riverImage?: Maybe<{
              __typename: "BasicImage";
              id: string;
              url: string;
              srcSet: string;
              width: number;
              height: number;
              altText: string;
            }>;
          } & LandingMetadata_MagazineArticle_Fragment)
        | ({
            __typename: "MagazineIssue";
            id: string;
            url: string;
            title: string;
            dek?: Maybe<string>;
            riverImage?: Maybe<{
              __typename: "BasicImage";
              id: string;
              url: string;
              srcSet: string;
              width: number;
              height: number;
              altText: string;
            }>;
          } & LandingMetadata_MagazineIssue_Fragment)
        | ({
            __typename: "NotesArticle";
            id: string;
            url: string;
            title: string;
            dek?: Maybe<string>;
            riverImage?: Maybe<{
              __typename: "BasicImage";
              id: string;
              url: string;
              srcSet: string;
              width: number;
              height: number;
              altText: string;
            }>;
          } & LandingMetadata_NotesArticle_Fragment)
        | ({
            __typename: "PhotoArticle";
            id: string;
            url: string;
            title: string;
            dek?: Maybe<string>;
            riverImage?: Maybe<{
              __typename: "BasicImage";
              id: string;
              url: string;
              srcSet: string;
              width: number;
              height: number;
              altText: string;
            }>;
          } & LandingMetadata_PhotoArticle_Fragment)
        | ({
            __typename: "PodcastEpisode";
            id: string;
            url: string;
            title: string;
            dek?: Maybe<string>;
            riverImage?: Maybe<{
              __typename: "BasicImage";
              id: string;
              url: string;
              srcSet: string;
              width: number;
              height: number;
              altText: string;
            }>;
          } & LandingMetadata_PodcastEpisode_Fragment)
        | ({
            __typename: "VideoArticle";
            id: string;
            url: string;
            title: string;
            dek?: Maybe<string>;
            riverImage?: Maybe<{
              __typename: "BasicImage";
              id: string;
              url: string;
              srcSet: string;
              width: number;
              height: number;
              altText: string;
            }>;
          } & LandingMetadata_VideoArticle_Fragment);
    }>;
  };
};

type ChannelPinnedArticle_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
    attributionText: string;
  }>;
} & LandingMetadata_BlogArticle_Fragment;

type ChannelPinnedArticle_CuratedArticle_Fragment = {
  __typename: "CuratedArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
    attributionText: string;
  }>;
} & LandingMetadata_CuratedArticle_Fragment;

type ChannelPinnedArticle_HomepagePromoItem_Fragment = {
  __typename: "HomepagePromoItem";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
    attributionText: string;
  }>;
} & LandingMetadata_HomepagePromoItem_Fragment;

type ChannelPinnedArticle_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
    attributionText: string;
  }>;
} & LandingMetadata_MagazineArticle_Fragment;

type ChannelPinnedArticle_MagazineIssue_Fragment = {
  __typename: "MagazineIssue";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
    attributionText: string;
  }>;
} & LandingMetadata_MagazineIssue_Fragment;

type ChannelPinnedArticle_NotesArticle_Fragment = {
  __typename: "NotesArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
    attributionText: string;
  }>;
} & LandingMetadata_NotesArticle_Fragment;

type ChannelPinnedArticle_PhotoArticle_Fragment = {
  __typename: "PhotoArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
    attributionText: string;
  }>;
} & LandingMetadata_PhotoArticle_Fragment;

type ChannelPinnedArticle_PodcastEpisode_Fragment = {
  __typename: "PodcastEpisode";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
    attributionText: string;
  }>;
} & LandingMetadata_PodcastEpisode_Fragment;

type ChannelPinnedArticle_VideoArticle_Fragment = {
  __typename: "VideoArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
    attributionText: string;
  }>;
} & LandingMetadata_VideoArticle_Fragment;

export type ChannelPinnedArticleFragment =
  | ChannelPinnedArticle_BlogArticle_Fragment
  | ChannelPinnedArticle_CuratedArticle_Fragment
  | ChannelPinnedArticle_HomepagePromoItem_Fragment
  | ChannelPinnedArticle_MagazineArticle_Fragment
  | ChannelPinnedArticle_MagazineIssue_Fragment
  | ChannelPinnedArticle_NotesArticle_Fragment
  | ChannelPinnedArticle_PhotoArticle_Fragment
  | ChannelPinnedArticle_PodcastEpisode_Fragment
  | ChannelPinnedArticle_VideoArticle_Fragment;

export type LandingIssueFragment = {
  __typename: "MagazineArticle";
  issue: { __typename: "MagazineIssue"; issueName: string; url: string };
};

export type LandingAuthorFragment = {
  __typename: "Author";
  id: string;
  slug: string;
  displayName: string;
};

type LandingMetadata_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LandingAuthorFragment>;
};

type LandingMetadata_CuratedArticle_Fragment = {
  __typename: "CuratedArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LandingAuthorFragment>;
};

type LandingMetadata_HomepagePromoItem_Fragment = {
  __typename: "HomepagePromoItem";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LandingAuthorFragment>;
};

type LandingMetadata_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LandingAuthorFragment>;
} & LandingIssueFragment;

type LandingMetadata_MagazineIssue_Fragment = {
  __typename: "MagazineIssue";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LandingAuthorFragment>;
};

type LandingMetadata_NotesArticle_Fragment = {
  __typename: "NotesArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LandingAuthorFragment>;
};

type LandingMetadata_PhotoArticle_Fragment = {
  __typename: "PhotoArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LandingAuthorFragment>;
};

type LandingMetadata_PodcastEpisode_Fragment = {
  __typename: "PodcastEpisode";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LandingAuthorFragment>;
};

type LandingMetadata_VideoArticle_Fragment = {
  __typename: "VideoArticle";
  datePublished?: Maybe<string>;
  authors: Array<{ __typename: "Author" } & LandingAuthorFragment>;
};

export type LandingMetadataFragment =
  | LandingMetadata_BlogArticle_Fragment
  | LandingMetadata_CuratedArticle_Fragment
  | LandingMetadata_HomepagePromoItem_Fragment
  | LandingMetadata_MagazineArticle_Fragment
  | LandingMetadata_MagazineIssue_Fragment
  | LandingMetadata_NotesArticle_Fragment
  | LandingMetadata_PhotoArticle_Fragment
  | LandingMetadata_PodcastEpisode_Fragment
  | LandingMetadata_VideoArticle_Fragment;

type LandingPromoItem_BlogArticle_Fragment = {
  __typename: "BlogArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
} & LandingMetadata_BlogArticle_Fragment;

type LandingPromoItem_CuratedArticle_Fragment = {
  __typename: "CuratedArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
} & LandingMetadata_CuratedArticle_Fragment;

type LandingPromoItem_HomepagePromoItem_Fragment = {
  __typename: "HomepagePromoItem";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
} & LandingMetadata_HomepagePromoItem_Fragment;

type LandingPromoItem_MagazineArticle_Fragment = {
  __typename: "MagazineArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
} & LandingMetadata_MagazineArticle_Fragment;

type LandingPromoItem_MagazineIssue_Fragment = {
  __typename: "MagazineIssue";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
} & LandingMetadata_MagazineIssue_Fragment;

type LandingPromoItem_NotesArticle_Fragment = {
  __typename: "NotesArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
} & LandingMetadata_NotesArticle_Fragment;

type LandingPromoItem_PhotoArticle_Fragment = {
  __typename: "PhotoArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
} & LandingMetadata_PhotoArticle_Fragment;

type LandingPromoItem_PodcastEpisode_Fragment = {
  __typename: "PodcastEpisode";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
} & LandingMetadata_PodcastEpisode_Fragment;

type LandingPromoItem_VideoArticle_Fragment = {
  __typename: "VideoArticle";
  id: string;
  url: string;
  title: string;
  dek?: Maybe<string>;
  riverImage?: Maybe<{
    __typename: "BasicImage";
    id: string;
    url: string;
    srcSet: string;
    width: number;
    height: number;
    altText: string;
  }>;
} & LandingMetadata_VideoArticle_Fragment;

export type LandingPromoItemFragment =
  | LandingPromoItem_BlogArticle_Fragment
  | LandingPromoItem_CuratedArticle_Fragment
  | LandingPromoItem_HomepagePromoItem_Fragment
  | LandingPromoItem_MagazineArticle_Fragment
  | LandingPromoItem_MagazineIssue_Fragment
  | LandingPromoItem_NotesArticle_Fragment
  | LandingPromoItem_PhotoArticle_Fragment
  | LandingPromoItem_PodcastEpisode_Fragment
  | LandingPromoItem_VideoArticle_Fragment;

export type LandingRiverFragment = {
  __typename: "RiverConnection";
  pageInfo: {
    __typename: "PageInfo";
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor?: Maybe<string>;
    endCursor?: Maybe<string>;
  };
  edges: Array<{
    __typename: "PromoEdge";
    cursor: string;
    node:
      | ({ __typename: "BlogArticle" } & LandingPromoItem_BlogArticle_Fragment)
      | ({
          __typename: "CuratedArticle";
        } & LandingPromoItem_CuratedArticle_Fragment)
      | ({
          __typename: "HomepagePromoItem";
        } & LandingPromoItem_HomepagePromoItem_Fragment)
      | ({
          __typename: "MagazineArticle";
        } & LandingPromoItem_MagazineArticle_Fragment)
      | ({
          __typename: "MagazineIssue";
        } & LandingPromoItem_MagazineIssue_Fragment)
      | ({
          __typename: "NotesArticle";
        } & LandingPromoItem_NotesArticle_Fragment)
      | ({
          __typename: "PhotoArticle";
        } & LandingPromoItem_PhotoArticle_Fragment)
      | ({
          __typename: "PodcastEpisode";
        } & LandingPromoItem_PodcastEpisode_Fragment)
      | ({
          __typename: "VideoArticle";
        } & LandingPromoItem_VideoArticle_Fragment);
  }>;
};

export type ChannelQueryVariables = Exact<{
  slug: Scalars["String"];
  after?: Maybe<Scalars["String"]>;
  before?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
}>;

export type ChannelQuery = {
  __typename: "Query";
  channel: {
    __typename: "Channel";
    id: string;
    slug: string;
    displayName: string;
    metaDescription: string;
    grapeshot?: Maybe<{ __typename: "Grapeshot"; segments: Array<string> }>;
    pinnedArticle?: Maybe<
      | ({
          __typename: "BlogArticle";
        } & ChannelPinnedArticle_BlogArticle_Fragment)
      | ({
          __typename: "CuratedArticle";
        } & ChannelPinnedArticle_CuratedArticle_Fragment)
      | ({
          __typename: "HomepagePromoItem";
        } & ChannelPinnedArticle_HomepagePromoItem_Fragment)
      | ({
          __typename: "MagazineArticle";
        } & ChannelPinnedArticle_MagazineArticle_Fragment)
      | ({
          __typename: "MagazineIssue";
        } & ChannelPinnedArticle_MagazineIssue_Fragment)
      | ({
          __typename: "NotesArticle";
        } & ChannelPinnedArticle_NotesArticle_Fragment)
      | ({
          __typename: "PhotoArticle";
        } & ChannelPinnedArticle_PhotoArticle_Fragment)
      | ({
          __typename: "PodcastEpisode";
        } & ChannelPinnedArticle_PodcastEpisode_Fragment)
      | ({
          __typename: "VideoArticle";
        } & ChannelPinnedArticle_VideoArticle_Fragment)
    >;
    editorialProject?: Maybe<
      { __typename: "EditorialProject" } & ChannelEditorialProjectFragment
    >;
    river: { __typename: "RiverConnection" } & LandingRiverFragment;
  };
};

export type ArticleInitialPropsQueryVariables = Exact<{
  id: Scalars["ID"];
  preview?: Maybe<Scalars["String"]>;
}>;

export type ArticleInitialPropsQuery = {
  __typename: "Query";
  article:
    | {
        __typename: "BlogArticle";
        id: string;
        isTnfCompatible: boolean;
        layout: ArticleLayout;
        hasMeter?: Maybe<boolean>;
        url: string;
      }
    | {
        __typename: "MagazineArticle";
        id: string;
        isTnfCompatible: boolean;
        layout: ArticleLayout;
        hasMeter?: Maybe<boolean>;
        url: string;
      };
};

export type HomepageQueryVariables = Exact<{ [key: string]: never }>;

export type HomepageQuery = {
  __typename: "Query";
  breakingNews?: Maybe<{
    __typename: "BreakingNews";
    homepageEnabled: boolean;
  }>;
};

export type MostPopularQueryVariables = Exact<{
  after?: Maybe<Scalars["String"]>;
  before?: Maybe<Scalars["String"]>;
  first?: Maybe<Scalars["Int"]>;
  last?: Maybe<Scalars["Int"]>;
}>;

export type MostPopularQuery = {
  __typename: "Query";
  mostPopular: {
    __typename: "CuratedGroup";
    id: string;
    slug: string;
    grapeshot?: Maybe<{ __typename: "Grapeshot"; segments: Array<string> }>;
    river: { __typename: "RiverConnection" } & LandingRiverFragment;
  };
};
